<template> 
<div> 
 <div v-if="data.themeType=='Tuktuk' || data.themeType=='TuktukStep1'" :class="embed && data.themeType=='Tuktuk' ? 'theme--Tuktuk-embed' : embed && data.themeType=='TuktukStep1' ? 'theme--Tuktuk-embed1' : '' ">  
  <Tuktuk class="embed-wrapper"  :data="{
        showProductImages:data.showProductImages,    
        priceWithoutWhosale,
        productImages:filteredProductImages,
        cartPrice:price,        
        payload,
        checkout_data,
        ...data,
        discountLists,
        isSizeWindow:mobileVersion,
        variantImageIndex,
        isVariableItemSelected,
        cartSummary,
        cartQuantity,
        errors,
        courierOptionDataFinal: courierListRegular,
        courierOptionDataCargo: courierListCargo,     
        selectedbumpArray,
        totalPrice,
        VATPrice,
        shippingDiscountValue,
        codPrice,
        deliveryCourierPrice,
        isShowVariantImage,
        show,
        cartTotal, 
        filterAttributes,
        cartMessage,
        isBuyButtonLoading,
        loadingPrice,
        cartMessage,
        shippingWeight:weight,       
       
        embed,
        totalQuantity,
        shippingCourierTypesCargo: shippingCourierTypesCargo
      }" 
      :user="user"
      :is-mobile="mobileVersion"
      :shippingCourierTypesCargo="shippingCourierTypesCargo"
      @updateCartQuantity="updateCartQuantity" 
      @addCartItem="addCartItem" 
      :submited="submited" 
      :shippingCourierItems="shippingCourierItems"
      :isInvalidCustomerPhone="isInvalidCustomerPhone"
      @reset-invalid-phone="resetInvalidPhone"
      @onSubmitted='submitted' 
      @addToCart="addToCart"
      @showMsg="showMsg"
      @updateCartTotal="updateCartTotal"
      @updateCartSummary="updateCartSummary"
      @applyDiscount="applyDiscount"
      @clearDiscount="clearDiscount" 
      @updateDiscountLists="updateDiscountLists" 
      @updateCheckout='handleAutofill'
      @setSelectedAddresses="setSelectedAddresses"
    />  
  </div> 
  <div v-else id="embed-checkout" class="embed-wrapper" :class='popup ? "" : "container-sm"'>  
    <ClassicTheme
      v-if="(!$route.query['old-design'] || $route.query['old-design'] !== 'true')"
      :config="config"
      :shippingCourierTypesCargo="shippingCourierTypesCargo"
      :shippingCourierItems="shippingCourierItems"
      :shippingCourierItemsCargo="shippingCourierItemsCargo"
      :user="user"
      :isMobile="mobileVersion"
      :isEmbed="embed"
      :isIOS="isIOS"
      :payload="payload"
      :checkout_data="checkout_data"
      :data="data"
      :errors="errors"
      :productImages="filteredProductImages"
      :changeVariant="changeVariant"
      :variantImageIndex="variantImageIndex"
      :filterAttributes="filterAttributes"
      :isVariableItemSelected="isVariableItemSelected"
      :cartQuantity="cartQuantity"
      :cartSummary="cartSummary"
      :selectedbumpArray="selectedbumpArray"
      :courierOptionDataFinal="courierListRegular"
      :courierOptionDataCargo="courierListCargo"
      :weight="weight"
      :discountLists="discountLists"
      :totalQuantity="totalQuantity"
      :totalPrice="totalPrice"
      :price="price"
      :priceWithoutWhosale="priceWithoutWhosale"
      :loadingPrice="loadingPrice"
      :cartTotal="cartTotal"
      :showCaptcha="showCaptcha"
      :shippingDiscountValue="shippingDiscountValue"
      :codPrice="codPrice"
      :VATPrice="VATPrice"
      :isBuyButtonLoading="isBuyButtonLoading"
      :isInvalidCustomerPhone="isInvalidCustomerPhone"
      :epaymentHelper="{ paymentFeeMethodName, calculateEpayFee }"
      @saveDataForNexttime="onSaveDataCheckbox"
      @updateCartQuantity="updateCartQuantity"
      @updateCartSummary="updateCartSummary"
      @addToCart="addToCart"
      @updateCartTotal="updateCartTotal"
      @applyDiscount="applyDiscount"
      @clearDiscount="clearDiscount"
      @updateDiscountLists="updateDiscountLists" 
      @validate="validate"
      @handleSubmit="submitted"
      @updateCheckout='handleAutofill'
      @reset-invalid-phone="resetInvalidPhone"
    />
    <div v-else class="flex justify-center" :class='popup ? "popup-main-wrapper" : embed ? "content-page-empty content-page-empty--embed" : "content-page-empty"'
      :style='popup ? "" : embed ? "margin: 0 auto; padding: 15px; width: 100%;max-width: 466px;" : ""'>
      <div class="content content-empty"
      :class="{
        'Nosidebar-width': data.templateType.startsWith('NoSidebar') || embed,
        'RightLeftsidebar-width': !(data.templateType.startsWith('NoSidebar') || embed),
        'nosidebar-narrow-canvas-width': data.templateType === 'NoSidebarNarrowCanvas',
      }">
        <ValidationObserver ref="form" tag="div">
        <div class='meng-card embed-topSpace'>
          <div :class='popup ? "" : "embed-checkout__container meng-card-body embed-gap"'>
            <div
              v-if='(data.headerImage && data.themeType == "Classic") || 
                (data.headerImage && data.themeType != "Classic" && data.templateType != "NoSidebar") ||
                data.showTitle && data.title ||
                data.showTagline && data.tagline' 
              class="embed-checkout__header row"
              :class="{'embed-checkout__header_nosidebar-narrow-canvas': data.templateType === 'NoSidebarNarrowCanvas'}" >
              <div
                v-if='(data.headerImage && data.themeType == "Classic") || (data.headerImage && data.themeType != "Classic" && data.templateType != "NoSidebar")'
                class='flex imgBox justify-center col-md-12 p-0'>
                <HeaderImage :headerImage='data.headerImage' :baseUrl="baseUrl" />
              </div>
              <div class='embed-checkout__header__text col-md-12 p-0'>
                <h1 v-show='data.showTitle && data.title'>{{ data.title }}</h1>
                <p v-show='data.showTagline && data.tagline'>{{ data.tagline }}</p>
              </div>
            </div>

            <div class="embed-notopMargin" :class='embed && popup ? "noMarginInMobile" : ""'>
              <div class='embed-checkout-main preview-main embed-bgHide'
              :class="{
                      'checkout-nosidebar classic': data.templateType === 'NoSidebar' && data.themeType === 'Classic',
                      'checkout-nosidebar minimalist': data.templateType === 'NoSidebar' && data.themeType !== 'Classic',
                      'checkout-nosidebar-narrow-canvas classic': data.templateType === 'NoSidebarNarrowCanvas' && data.themeType === 'Classic',
                     }"
              >
                <div class="embed-checkout-main__container" :class="{'main-container-canvas-narrow': data.templateType === 'NoSidebarNarrowCanvas', 'is-mobile': mobileVersion}">
                  <template v-for="(pos, posIndex) in compfieldsPositionMobile">

                    <template v-if="displayDiv(pos.name, 'guaranteeSeal') && !embed">
                      <div v-bind:key="posIndex" class="embed-sealHide no-sidebar"
                        v-if='((!mobileVersion && data.showSeals) || (mobileVersion && (pos.showHideButton ? pos[pos.buttonVar] : true))) && (data.templateType == "NoSidebar" || (data.themeType == "Classic" && data.templateType == "LeftSidebar" && mobileVersion))'>
                        <div :class='data.templateType == "NoSidebar" ? "no-sidebar" : ""'>
                          <Seal :data='data' />
                        </div>
                      </div>
                    </template>

                    <!-- RIGHT SIDEBAR -->
                    <div id="right-sidebar" :data-name="pos.name"
                      v-bind:key="posIndex + '-rightSidebar'" 
                      v-if="
                        (!mobileVersion && data.templateType == 'RightSidebar') ||
                        (mobileVersion && data.templateType == 'RightSidebar') && (
                          (pos.name === 'bump' && data.bumpArray.length > 0) ||
                          (pos.name === 'productDetails' && data.attributes.map(attr => attr.name).filter(Boolean).length > 0) ||
                          (pos.name === 'productImage' && !embed && productImages.length > 0) ||
                          (pos.name === 'componentVideo' && payload.componentVideo) ||
                          (pos.name === 'guaranteeSeal' && !embed) ||
                          (pos.name === 'content_bullets' && !embed) ||
                          (pos.name === 'otherContent' && data.otherContent) ||
                          (pos.name === 'payment' && data.paymentType && data.paymentType.filter((p) => p.active).length > 0) ||
                          !['bump','productDetails','productImage', 'componentVideo', 'otherContent', 'payment', 'guaranteeSeal', 'content_bullets'].includes(pos.name)
                        ) &&
                        (mobileVersion && showProductVariants(pos.name))
                      "
                      :style="{
                        marginTop: ((pos.name === 'productDetails' && data.type !== 'variable') || (pos.name === 'buyButton' && data.floatingButton)) ? '0 !important' : undefined,
                        display: (pos.name === 'saveThisInformation' && data.saveInfoWithoutEnable) || (pos.name === 'shipping' && !shouldRender(pos))
                          ? 'none !important'
                          : undefined,
                      }"
                      :class="mobileVersion ? (['guaranteeSeal', 'requestedFields', 'saveThisInformation', 'payment', 'buyButton', 'orderSummary','componentVideo'].includes(pos.name) ? 'rightSideBar' : '') : 'rightSideBar'">
                      <!-- only in embed-popup -->
                      <div v-if="embed && popup">
                        <div class='embed-checkout-left-col checkout-detail embed-leftSidebar-popup-width'
                          :class="data.themeType != 'Classic' ? 'minimalist' : 'classic-right'">
                          <Left :selectedbumpArray="selectedbumpArray" :totalBumpOrderPrice="totalBumpOrderPrice"
                            :popup='popup' :embed='embed' :data='data' :form='form' :payload='payload'
                            :codPrice='codPrice' :priceWithoutWhosale='priceWithoutWhosale' :loadingPrice='loadingPrice' :isBuyButtonLoading='isBuyButtonLoading'
                            :delivery='delivery' :price='price' :weight='weight' :quantity='cartQuantity'
                            :totalPrice='totalPrice' :VATPrice='VATPrice' :isSizeWindow='mobileVersion' :cartSummary="cartSummary"
                            :cartTotal="cartTotal" :showCaptcha="showCaptcha" :pos="pos" :posName="pos.name"
                            :productImages="productImages"
                            :variantImageIndex="variantImageIndex"
                            :posIndex="posIndex" :shippingDiscountValue="shippingDiscountValue"
                            @updateCartTotal="updateCartTotal" @onSave='save'
                            @updateCartSummary='updateCartSummary' @cartOrderSummary='openCartSummary' :errors="errors"
                            @onValidate="validate" :submited="submited" @onSubmitted='submitted' />
                            
                        </div>
                      </div>

                      <!-- :class="mobileVersion ? (['guaranteeSeal', 'requestedFields', 'saveThisInformation', 'payment','buyButton','orderSummary'].includes(posName) ? 'embed-checkout-right-col embed-rightHide checkout-form':'') : 'embed-checkout-right-col embed-rightHide checkout-form'" -->
                      <div class="embed-checkout-right-col embed-rightHide checkout-form"
                        :style="!data.showProductImages && !data.orderSummary && data.bullets.length == 0 ? 'margin:auto;' : ''">
                        <Right :discountLists="discountLists" :selectedbumpArray="selectedbumpArray" :popup='popup' :embed="embed" :data='data'
                          :form='form' :payload='payload' :codPrice='codPrice' :priceWithoutWhosale='priceWithoutWhosale'
                          :loadingPrice='loadingPrice' :isBuyButtonLoading='isBuyButtonLoading' :delivery='delivery' :price='price' :weight='weight'
                          :quantity='quantity' :totalPrice='totalPrice' :VATPrice='VATPrice' :isSizeWindow='mobileVersion'
                          :cartSummary="cartSummary" :cartQuantity="cartQuantity" :cartTotal="cartTotal"
                          :showCaptcha="showCaptcha" :pos="pos" :posName="pos.name" :posIndex="posIndex"
                          :productImages="productImages"
                          :variantImageIndex="variantImageIndex"
                          :is-mobile="mobileVersion" :modalVariantOpen="changeVariant"
                          :courierOptionDataFinal="courierOptionDataAvailable" :shippingDiscountValue="shippingDiscountValue" :filterAttributes="filterAttributes" :isVariableItemSelected="isVariableItemSelected"      
                          @updateCartTotal="updateCartTotal" @addToCart="addToCart" @onSave='save'
                          @cartOrderSummary='openCartSummary' @showMobile="updateMobileView"
                          @updateCheckout='handleAutofill' @updateCartSummary="updateCartSummary"
                          @updateCartQuantity="updateCartQuantity" :errors="errors" @onValidate="validate"
                          :submited="submited" @onSubmitted='submitted' :user="user" @applyDiscount="applyDiscount"  @clearDiscount="clearDiscount" @updateDiscountLists="updateDiscountLists" :totalQuantity="totalQuantity" :allEstimatePublic="allEstimatePublic"
                          @onAddressChange="onAddressChange" />
                        <div v-if='!popup && data.templateType !== "NoSidebar" && displayCopyright(posIndex)'
                          class='bottom-bar-text'>
                          <div class='copyright-content '>
                              <div v-if="data.isPoweredBy" class='copyright-text__poweredby'>
                                  <p class="copyright-text__poweredby__text">Powered by</p> 
                                  <img width="70" height="14" src='@/assets/images/formulir-logo-black.svg'/>
                              </div>
                              <p class="copyright-content__text" v-if="data.isCopyright !== false">Copyright © {{new Date() | year_format}}</p>
                          </div>
                        </div>
                      </div>

                      <div class='embed-checkout-left-col embed-leftHide checkout-detail'
                        :class="data.themeType != 'Classic' ? 'minimalist' : 'classic-right'"
                        style="margin-top: 0 !important"
                        v-if='(data.themeType != "Classic" || (data.themeType == "Classic" && data.templateType != "RightSidebar") || (data.themeType == "Classic" && data.templateType == "RightSidebar" && !mobileVersion))'>
                        <Left :selectedbumpArray="selectedbumpArray" :totalBumpOrderPrice="totalBumpOrderPrice"
                          :popup='popup' :embed='embed' :data='data' :form='form' :payload='payload' :codPrice='codPrice'
                          :priceWithoutWhosale='priceWithoutWhosale' :loadingPrice='loadingPrice' :isBuyButtonLoading='isBuyButtonLoading' :delivery='delivery'
                          :price='price' :weight='weight' :cartQuantity='cartQuantity' :quantity='quantity'
                          :totalPrice='totalPrice' :VATPrice='VATPrice' :cartTotal="cartTotal" :showCaptcha="showCaptcha" :pos="pos"
                          :productImages="productImages"
                            :variantImageIndex="variantImageIndex"
                          :posName="pos.name" :posIndex="posIndex" @updateCartTotal="updateCartTotal"
                          @updateCartSummary='updateCartSummary' :isSizeWindow='mobileVersion' :cartSummary="cartSummary" :shippingDiscountValue="shippingDiscountValue"
                          @onSave='save' @cartOrderSummary='openCartSummary' :errors="errors" @onValidate="validate"
                          :submited="submited" @onSubmitted='submitted' />
                          <div v-if='!popup && data.templateType !== "NoSidebar" && displayCopyright(posIndex)'
                            class='bottom-bar-text'>
                            <div class='copyright-content'>
                                <div v-if="data.isPoweredBy" class='copyright-text__poweredby'>
                                    <p class="copyright-text__poweredby__text">Powered by</p> 
                                    <img  width="70" height="14" src='@/assets/images/formulir-logo-black.svg' />
                                </div>
                                <p class="copyright-content__text" v-if="data.isCopyright !== false">Copyright © {{new Date() | year_format}}</p>
                            </div>
                          </div>
                      </div>

                      <!-- Footer logo in embed-popup -->
                      <div v-if="embed && popup && displayCopyright(posIndex)" class="embed-rightSidebar-popup-footer">
                        <div class='flex justify-center poweredby-text power_block' style="opacity: 0.2;">Powered by
                          <img  width="70" height="14" class='ml-1' src='@/assets/images/formulir-logo-black.svg' />
                        </div>
                        <div v-if="data.isCopyright !== false" class='text-center copyright-texxt mt-10'>Copyright © {{ new Date() | year_format }}</div>
                      </div>

                    </div>

                    <!-- LEFT SIDEBAR  -->
                    <div id="left-sidebar" :data-name="pos.name"
                      v-bind:key="posIndex + '-leftSidebar'" 
                      v-if='(data.templateType == "LeftSidebar" && !mobileVersion) || (data.templateType == "LeftSidebar" && mobileVersion && (
                        (pos.name === "productDetails" && data.attributes.map(attr => attr.name).filter(Boolean).length > 0) ||
                        (pos.name === "bump" && data.isBump && data.bumpArray && data.bumpArray.length >= 0 && selectedbumpArray) ||
                        (pos.name === "productImage" && !embed && productImages.length > 0) ||
                        (pos.name === "componentVideo" && payload.componentVideo) ||
                        (pos.name === "guaranteeSeal" && !embed) ||
                        (pos.name === "content_bullets" && !embed) ||
                        (pos.name === "otherContent" && data.otherContent) ||
                        (pos.name === "payment" && data.paymentType && data.paymentType.filter((p) => p.active).length > 0) ||
                        !["bump","productDetails","productImage", "componentVideo", "otherContent", "payment", "guaranteeSeal", "content_bullets"].includes(pos.name) &&
                        (mobileVersion && showProductVariants(pos.name))
                      ))'
                      :style="{
                        marginTop: pos.name === 'buyButton' && data.floatingButton ? '0 !important' : undefined, 
                        display: (pos.name === 'saveThisInformation' && data.saveInfoWithoutEnable) || (pos.name === 'shipping' && !shouldRender(pos))
                          ? 'none !important'
                          : undefined,
                      }"
                      class="leftSideBar">
                      <!-- only in embed-popup -->
                      <div v-if='embed && popup'>
                        <div class='embed-checkout-left-col checkout-detail embed-leftSidebar-popup-width'
                          :class="data.themeType != 'Classic' ? 'minimalist' : 'classic-right'">
                          <Left :selectedbumpArray="selectedbumpArray" :totalBumpOrderPrice="totalBumpOrderPrice"
                            :popup='popup' :embed='embed' :data='data' :form='form' :payload='payload'
                            :codPrice='codPrice' :priceWithoutWhosale='priceWithoutWhosale' :loadingPrice='loadingPrice' :isBuyButtonLoading='isBuyButtonLoading'
                            :delivery='delivery' :price='price' :weight='weight' :quantity='cartQuantity'
                            :totalPrice='totalPrice' :VATPrice='VATPrice' :isSizeWindow='mobileVersion' :cartSummary="cartSummary"
                            :cartTotal="cartTotal" :showCaptcha="showCaptcha" :pos="pos" :posName="pos.name"
                            :productImages="productImages"
                            :variantImageIndex="variantImageIndex"
                            :posIndex="posIndex" :shippingDiscountValue="shippingDiscountValue" @updateCartTotal="updateCartTotal" @onSave='save'
                            @updateCartSummary='updateCartSummary' @cartOrderSummary='openCartSummary' :errors="errors"
                            @onValidate="validate" :submited="submited" @onSubmitted='submitted' />
                        </div>
                      </div>

                      <div class='embed-checkout-left-col embed-leftHide checkout-detail'
                        :class="data.themeType != 'Classic' ? 'minimalist' : 'classic-left'"
                        v-if="data.showProductImages || data.bullets.length || data.orderSummary">
                        <Left :selectedbumpArray="selectedbumpArray" :totalBumpOrderPrice="totalBumpOrderPrice"
                          :popup='popup' :embed='embed' :data='data' :form='form' :payload='payload' :codPrice='codPrice'
                          :priceWithoutWhosale='priceWithoutWhosale' :loadingPrice='loadingPrice' :isBuyButtonLoading='isBuyButtonLoading' :delivery='delivery'
                          :price='price' :weight='weight' :quantity='quantity' :cartQuantity='cartQuantity'
                          :totalPrice='totalPrice' :VATPrice='VATPrice' :isSizeWindow='mobileVersion' :cartSummary="cartSummary"
                          :showCaptcha="showCaptcha" :pos="pos" :posName="pos.name" :posIndex="posIndex"
                          :productImages="productImages"
                          :variantImageIndex="variantImageIndex"
                          :cartTotal="cartTotal" :shippingDiscountValue="shippingDiscountValue"
                          @updateCartTotal="updateCartTotal"
                          @updateCartSummary='updateCartSummary' @onSave='save' @cartOrderSummary='openCartSummary'
                          :errors="errors" @onValidate="validate" :submited="submited" @onSubmitted='submitted' />
                          <div v-if='!popup && data.templateType !== "NoSidebar" && displayCopyright(posIndex)'
                            class='bottom-bar-text'>
                            <div class='copyright-content'>
                                <div v-if="data.isPoweredBy" class='copyright-text__poweredby'>
                                    <p class="copyright-text__poweredby__text">Powered by</p> 
                                    <img  width="70" height="14" class='ml-1' src='@/assets/images/formulir-logo-black.svg' />
                                </div>
                                <p class="copyright-content__text" v-if="data.isCopyright !== false">Copyright © {{new Date() | year_format}}</p>
                            </div>
                          </div>
                      </div>

                      <div class="embed-checkout-right-col embed-rightHide checkout-form"
                        :style="!data.showProductImages && !data.orderSummary && data.bullets.length == 0 ? 'margin:auto;' : ''">
                        <Right :discountLists="discountLists" :popup='popup' :embed='embed' :data='data' :form='form' :payload='payload'
                          :codPrice='codPrice' :priceWithoutWhosale='priceWithoutWhosale' :loadingPrice='loadingPrice' :isBuyButtonLoading='isBuyButtonLoading'
                          :delivery='delivery' :price='price' :weight='weight' :quantity='quantity'
                          :totalPrice='totalPrice' :VATPrice='VATPrice' :isSizeWindow='mobileVersion' :cartSummary="cartSummary"
                          :cartQuantity="cartQuantity" :cartTotal="cartTotal" :showCaptcha="showCaptcha"
                          :selectedbumpArray="selectedbumpArray" :pos="pos" :posName="pos.name" :posIndex="posIndex"
                          :productImages="productImages"
                          :variantImageIndex="variantImageIndex"
                          :is-mobile="mobileVersion" :modalVariantOpen="changeVariant"
                          :courierOptionDataFinal="courierOptionDataAvailable" :shippingDiscountValue="shippingDiscountValue" :filterAttributes="filterAttributes" :isVariableItemSelected="isVariableItemSelected"      
                          @updateCartTotal='updateCartTotal' @onSave='save' @addToCart="addToCart"
                          @cartOrderSummary='openCartSummary' @updateCartSummary='updateCartSummary'
                          @showMobile="updateMobileView" @updateCheckout='handleAutofill'
                          @updateCartQuantity="updateCartQuantity" :errors="errors" @onValidate="validate"
                          :submited="submited" @onSubmitted='submitted' :user="user" @applyDiscount="applyDiscount"  @clearDiscount="clearDiscount" :totalQuantity="totalQuantity" :allEstimatePublic="allEstimatePublic"
                          @onAddressChange="onAddressChange" />
                          <div v-if='!popup && data.templateType !== "NoSidebar" && displayCopyright(posIndex)'
                            class='bottom-bar-text'>
                            <div class='copyright-content'>
                                <div v-if="data.isPoweredBy" class='copyright-text__poweredby'>
                                    <p class="copyright-text__poweredby__text">Powered by</p> 
                                    <img  width="70" height="14" src='@/assets/images/formulir-logo-black.svg' />
                                </div>
                                <p class="copyright-content__text" v-if="data.isCopyright !== false">Copyright © {{new Date() | year_format}}</p>
                            </div>
                          </div>
                      </div>

                      <!-- Footer logo in embed-popup -->
                      <div v-if="embed && popup && displayCopyright(posIndex)" class="embed-leftSidebar-popup-footer">
                        <div class='flex justify-center poweredby-text power_block' style="opacity: 0.2;">Powered by
                          <img  width="70" height="14" class='ml-1' src='@/assets/images/formulir-logo-black.svg' />
                        </div>
                        <div v-if="data.isCopyright !== false" class='text-center copyright-texxt mt-10'>Copyright © {{ new Date() | year_format }}</div>
                      </div>
                    </div>

                    <!-- NO SIDEBAR  -->
                    <div id="no-sidebar" 
                      v-if="
                        (!mobileVersion && data.templateType == 'NoSidebar') ||
                        (mobileVersion && data.templateType == 'NoSidebar') && (
                          (pos.name === 'bump' && data.bumpArray.length > 0) ||
                          (pos.name === 'productDetails' && data.attributes.map(attr => attr.name).filter(Boolean).length > 0) ||
                          (pos.name === 'productImage' && productImages.length > 0) ||
                          (pos.name === 'componentVideo' && payload.componentVideo) ||
                          (pos.name === 'otherContent' && data.otherContent) ||
                          (pos.name === 'payment' && data.paymentType && data.paymentType.filter((p) => p.active).length > 0) ||
                          !['bump','productDetails','productImage', 'componentVideo', 'otherContent', 'payment'].includes(pos.name)
                        ) &&
                        (mobileVersion && showProductVariants(pos.name))
                      "
                      v-bind:key="posIndex + '-noSidebar'" :data-name="pos.name"
                      :style='{
                        height: pos.name === "buyButton" && data.floatingButton ? "0 !important": undefined,
                        display: (pos.name === "productDetails" && data.type !== "variable") || (pos.name === "saveThisInformation" && data.saveInfoWithoutEnable) || (pos.name === "shipping" && !shouldRender(pos))
                          ? "none !important"
                          : undefined,
                      }'>

                        <div v-if="data.showProductImages || data.bullets.length" class='embed-checkout-left-col'
                          :class="embed && popup ? '' : 'embed-leftHide'" :style="{ display: mobileVersion && pos.name === 'requestedFields' ? 'none !important' : undefined }">
                          <Left :selectedbumpArray="selectedbumpArray" :totalBumpOrderPrice="totalBumpOrderPrice"
                            :popup='popup' :embed='embed' :data='data' :form='form' :payload='payload'
                            :codPrice='codPrice' :priceWithoutWhosale='priceWithoutWhosale' :loadingPrice='loadingPrice' :isBuyButtonLoading='isBuyButtonLoading'
                            :delivery='delivery' :price='price' :weight='weight' :quantity='quantity'
                            :cartQuantity='cartQuantity' :totalPrice='totalPrice' :VATPrice='VATPrice' :isSizeWindow='mobileVersion'
                            :cartSummary="cartSummary" :showCaptcha="showCaptcha" :pos="pos" :posName="pos.name"
                            :productImages="productImages"
                            :variantImageIndex="variantImageIndex"
                            :posIndex="posIndex" @onSave='save' 
                            :cartTotal="cartTotal"  :shippingDiscountValue="shippingDiscountValue"
                            @updateCartTotal='updateCartTotal'
                            @updateCartSummary='updateCartSummary'
                            @cartOrderSummary='openCartSummary' :errors="errors" @onValidate="validate"
                            :submited="submited" @onSubmitted='submitted' />
                        </div>
                        <div class="embed-checkout-right-col no-sidebar-form" v-if="pos.name !== 'guaranteeSeal'">
                          <Right :discountLists="discountLists" :selectedbumpArray="selectedbumpArray" :popup='popup' :embed='embed' :data='data'
                            :form='form' :payload='payload' :codPrice='codPrice'
                            :priceWithoutWhosale='priceWithoutWhosale' :loadingPrice='loadingPrice' :isBuyButtonLoading='isBuyButtonLoading' :delivery='delivery'
                            :price='price' :weight='weight' :noProductOptionQty='quantity' :totalPrice='totalPrice'
                            :VATPrice='VATPrice' :isSizeWindow='mobileVersion' :cartSummary="cartSummary" :cartQuantity="cartQuantity"
                            :cartTotal="cartTotal" :showCaptcha="showCaptcha" :pos="pos" :posName="pos.name"
                            :productImages="productImages"
                            :variantImageIndex="variantImageIndex"
                            :courierOptionDataFinal="courierOptionDataAvailable" :shippingDiscountValue="shippingDiscountValue" :filterAttributes="filterAttributes" :isVariableItemSelected="isVariableItemSelected"      
                            :posIndex="posIndex" @updateCartTotal='updateCartTotal' @onSave='save' @addToCart="addToCart"
                            :is-mobile="mobileVersion" :modalVariantOpen="changeVariant"
                            @cartOrderSummary='openCartSummary' @updateCartSummary='updateCartSummary'
                            @showMobile="updateMobileView" @updateCheckout='handleAutofill'
                            @updateCartQuantity="updateCartQuantity" :errors="errors" @onValidate="validate"
                            :submited="submited" @onSubmitted='submitted' :user="user" @applyDiscount="applyDiscount"  @clearDiscount="clearDiscount" @updateDiscountLists="updateDiscountLists" :totalQuantity="totalQuantity" :allEstimatePublic="allEstimatePublic"
                            @onAddressChange="onAddressChange" />
                        </div>

                        <!-- Footer logo in embed-popup -->
                        <div v-if="embed && popup && displayCopyright(posIndex)" class="embed-popup-footer">
                          <div class='flex justify-center poweredby-text power_block' style="opacity: 0.2;">Powered by
                            <img  width="70" height="14" class='ml-1' src='@/assets/images/formulir-logo-black.svg' />
                          </div>
                          <div v-if="data.isCopyright !== false" class='text-center copyright-texxt mt-10'>Copyright © {{ new Date() | year_format }}</div>
                        </div>
                    </div>

                    <div
                        class="no-sidebar-narrow-canvas"
                        v-if="data.templateType === 'NoSidebarNarrowCanvas' && posIndex === 0"
                        :key="posIndex + '-noSidebarNarrowCanvas'"
                        :data-name="pos.name"
                      >
                        <NoSidebarNarrowCanvas
                          :data="data"
                          :relatedData="{
                            selectedbumpArray,
                            totalBumpOrderPrice,
                            popup,
                            embed,
                            data,
                            form,
                            payload,
                            codPrice,
                            priceWithoutWhosale,
                            loadingPrice,
                            isBuyButtonLoading,
                            delivery,
                            discountLists,
                            price,
                            weight,
                            quantity,
                            totalPrice,
                            mobileVersion,
                            cartSummary,
                            cartQuantity,
                            cartTotal,
                            showCaptcha,
                            pos,
                            productImages,
                            totalQuantity,
                            variantImageIndex,
                            courierOptionDataFinal,
                            shippingDiscountValue,
                            filterAttributes,
                            isVariableItemSelected,
                            posIndex,
                            errors,
                            submited,
                            user,
                            VATPrice,
                            allEstimatePublic
                          }"
                          :producedFieldDatas="mobileVersion ? compfieldsPositionMobile.map((pos, posIndex) => ({...pos, posIndex})) : [pos]"
                          :is-mobile="mobileVersion"
                          @updateCartTotal="updateCartTotal"
                          @onSave="save"
                          @addToCart="addToCart"
                          @cartOrderSummary="openCartSummary"
                          @updateCartSummary="updateCartSummary"
                          @showMobile="updateMobileView"
                          @updateCheckout="handleAutofill"
                          @updateCartQuantity="updateCartQuantity"
                          @onValidate="validate"
                          @onSubmitted="submitted"
                          @applyDiscount="applyDiscount"
                          @clearDiscount="clearDiscount"
                          @updateDiscountLists="updateDiscountLists"
                        />
                    </div>

                    <div v-bind:key="posIndex + '-classic'"
                      v-if='data.themeType == "Classic" && displayCopyright(posIndex) && data.testimonials.length && data.showTestimonials' class="bottom-component"
                      :style="embed && popup && (data.testimonials.length == 0 || !data.showTestimonials) ? 'padding-bottom: 0;margin-top: 0;' : embed && popup && data.testimonials.length && data.showTestimonials ? 'padding-bottom:20px;' : ''">
                      <Bottom :popup='popup' :embed='embed' :data='data' :form='form' :payload='payload' :price='price'
                        :weight='weight' :quantity='quantity' :totalPrice='totalPrice' :VATPrice='VATPrice' @onSave='save' />
                    </div>

                    <div v-bind:key="posIndex + '-common'"
                      v-if='!popup && (data.templateType == "NoSidebar" || data.templateType == "NoSidebarNarrowCanvas") && (data.themeType == "Minimalism" || data.themeType == "Classic") && displayCopyright(posIndex)'
                      class='bottom-bar-text Nosidebar-container'>
                        <div class='copyright-content'>
                          <div v-if="data.isPoweredBy" class='copyright-text__poweredby'>
                              <p class="copyright-text__poweredby__text">Powered by</p> 
                              <img  width="70" height="14" src='@/assets/images/formulir-logo-black.svg' />
                          </div>
                          <p class="copyright-content__text" v-if="data.isCopyright !== false">Copyright © {{new Date() | year_format}}</p>
                        </div>
                    </div>
                  </template>
                  <template v-if='data.templateType == "LeftSidebar" || data.templateType == "RightSidebar"'>
                      <div class='copyright-content copyright-content--leftsidebar--mobile'>
                        <div v-if="data.isPoweredBy" class='copyright-text__poweredby'>
                            <p class="copyright-text__poweredby__text">Powered by</p> 
                            <img  width="70" height="14" src='@/assets/images/formulir-logo-black.svg' />
                        </div>
                        <p class="copyright-content__text" v-if="data.isCopyright !== false">Copyright © {{new Date() | year_format}}</p>
                      </div>
                  </template>
                </div>
                </div>
              </div>
            </div>
          </div>
        </ValidationObserver>
            <no-ssr>
            <!-- VARIANT MODAL -->
            <vs-dialog overflow-hidden class="pp-modal-vuesax variant-modal pp-modal-choose-variant--mobile" v-model="changeVariant">
              <div class="pp-modal-vuesax__container">
                <div class="bottom-sheet__drag-indicator">
                  <div />
                </div>
                <div class="pp-modal-vuesax__header">
                  <h4 class="modal-title">{{ $t('common.chooseVariant')}}</h4>
                </div>
                <hr style="margin: 0px !important;">
                <template v-if="(!(data.multiplyVariations && data.marketPlaceStyle && !data.cartOrder)) && chosenData">
                  <!-- PRODUCT IMAGE -->
                  <div class="pp-modal-choose-variant--mobile__thumbnail">
                    <template v-if="data.showProductImages && productImages.length>0">
                        <!-- PRODUCT IMAGE SINGLE -->
                        <div
                        v-if="variantImageIndex > -1"
                          class="pp-modal-choose-variant--mobile__thumbnail__single"
                        >
                        
                          <img
                            :alt="productImages[variantImageIndex].src"
                            :src="getSizedImageUrl( productImages[variantImageIndex].src,'medium','product-images')   
                            "
                          />
                        </div>
                        <div
                        v-else-if="productImages.length > 0"
                          class="pp-modal-choose-variant--mobile__thumbnail__single"
                        >
                          <img
                            :alt="productImages[0].src"
                            :src="getSizedImageUrl(productImages[0].src,'medium','product-images')"   
                          
                          />
                        </div>
                    </template>
                    <!-- <template v-if="data.showProductImages && productImages[0]">
                    
                      <div
                        v-if="productImages.length <= 1"
                        class="pp-modal-choose-variant--mobile__thumbnail__single"
                      >
                        <img
                          :alt="productImages[0].src"
                          :src="
                            getSizedImageUrl(productImages[0].src,'medium','product-images')
                          "
                        />
                      </div>

                    
                      <div
                        v-else
                        class="pp-modal-choose-variant--mobile__thumbnail__carousel"
                      >
                        <Carousel
                          :type="'product'"
                          :images="productImages"
                          :variantImageIndex="variantImageIndex"
                        />
                      </div>
                    </template> -->

                    <div class="pp-modal-choose-variant--mobile__thumbnail__content">
                      <div class="pp-modal-choose-variant--mobile__thumbnail__content__number">
                        <template v-if="chosenData.priceCompare > 0 && chosenData.priceCompare!=chosenData.price">
                          <h2 class="pp-modal-choose-variant--mobile__thumbnail__content__number__price">Rp{{chosenData.priceCompare | g_number_format}}</h2>
                          <p  class="pp-modal-choose-variant--mobile__thumbnail__content__before-discount">Rp{{chosenData.price | g_number_format}}</p>

                        </template>
                        <template v-else>
                          <h2 class="pp-modal-choose-variant--mobile__thumbnail__content__number__price">Rp{{chosenData.price | g_number_format}}</h2>
                        </template>

                        
                      

                      </div>
                      <p class="pp-modal-choose-variant--mobile__thumbnail__content__variant">{{chosenData.name}}</p>
                    </div>
                  </div>
                  <hr class="hr-2">
                </template>
                <!-- <div
                  v-if="data.showProductImages && productImages[0]"
                  class="pp-modal-choose-variant--mobile__thumbnail-container"
                >
                  <img
                    :alt="productImages[0].src"
                    :src="
                      baseUrl + '/uploads/product-images/' + productImages[0].src
                    "
                  />
                </div> -->
            
                <div class="pp-modal-vuesax__main" style="padding: 16px !important;">
                  <template v-if="data.multiplyVariations &&
                    data.marketPlaceStyle &&
                    !data.cartOrder
                    "
                    >
                  
                    <div 
                      :key="'variant' + i" 
                      v-for="(attr, i) in data.variablePrices" 
                      class="variant-option-qty variant-option-qty--no-border"
                      :class="{'mb-10' : i != data.variablePrices.length - 1}"
                    >
                      <div 
                        class="variant-option-qty__content" 
                        :class="isShowVariantImage?'variant-option-qty__content--show-thumbnail':''"
                      >
                        <div 
                          v-if="isShowVariantImage" 
                          class="variant-option-qty__content--show-thumbnail__thumbnail">
                          <img 
                            alt="" 
                            :src="getImageSrc(attr)"                         
                          />
                        </div>
                        <span class="variant-option-qty__content__label" :class="{'overflow-wrap--anywhere':isHasOneWordLongText(attr.name)}">{{ attr.name }}</span>
                      </div>
                      <div class="variant-option-qty__action">
                        <button
                          class="variant-option-qty__action__decrease"
                          @click="decrement(i, 'multipleVariant')"
                        >
                            <img src="@/assets/icons/ic-action-decrease.svg" alt="-"/>
                        </button>
                        <!-- <vs-input
                          min="0"
                          v-model="attr.qty"
                          readonly
                        /> -->
                        <div class="variant-option-qty__action__number">{{ attr.qty }}</div>
                        <button
                          class="variant-option-qty__action__increase"
                          @click="increment(i, 'multipleVariant')"
                        >
                          <img src="@/assets/icons/ic-action-increase.svg" alt="+"/>
                        </button>
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div >
                      <div v-if="data.attributes">
                        <div  v-for="(attr, i) in data.attributes" v-bind:key="i" class="text-left" :class="{'mb-10' : i != data.attributes.length - 1}">
                          <label class="text--label-field" style="margin-bottom: 8px !important;">{{
                            attr.name
                          }}</label>
                          <div class="flex flex-wrap variant-selected-btn" style="gap: 10px">
                            <div v-for="(attrval, j) in filteredProductVariant(attr.value, attr.name)" v-bind:key="j" :class="{'hide-variant':data.hideUnavailableVariant && checkOption(attr.name,attrval)}">
                              <div class="above-switch">
                                <selected-green-switch v-if="payload.variablePrices[attr.name + i.toString()]" v-model="payload.variablePrices[attr.name + i.toString()].name                 
                                  " :options="[
                                    {
                                      id: attrval,
                                      text: attrval,
                                      imgSrc:undefined,
                                      disabled:checkOption(attr.name,attrval),
                                      hideUnavailableVariant: data.hideUnavailableVariant
                                      
                                    },
                                  ]" full="99"></selected-green-switch>
                             
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <template v-if="data.addQuantity" >
                        <div class="add-quantity mt-20">
                          <label class="text--label-field" style="margin-bottom: 8px !important;">{{ $t('common.quantity') }}</label>
                          <div class="col-5 flex increDecre-btn-wrap" style="max-width: 125px; border-radius: 8px">
                            <div class="minus-btn pointer" @click="decrement(0, 'singleVariant')">
                              <div class="bg-pm-btn relative">
                                <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4.1665 10.488H15.8332" stroke="#6C7E95" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                              </div>
                            </div>
                            <div>
                              <vs-input min="0" v-model="cartQuantity"
                                class="vs-form-control qty-input no-bg disabled p-0" />
                            </div>
                            <div class="plus-btn pointer" @click="increment(0, 'singleVariant')">
                              <div class="bg-pm-btn relative">
                                <svg width="20" height="20" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10 5.48804L10 15.488M15 10.488L5 10.488" stroke="#6C7E95" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </template>
                </div>

                <div v-if="(loadingPrice && data.variablePrices && data.enableProductOptions && data.variablePrices.length>0 && !isVariableItemSelected)" class="alert-warning1 mb-20 title-font error align-items-start d-flex">
                  <img
                    class="mr-10"
                    src="@/assets/icons/error.svg"
                  />
                  Kombinasi variasi ini tidak tersedia
                </div>              
                <div class="pp-modal-vuesax__footer" style="padding: 16px 16px 24px !important;">              
                  <button v-if="data.cartOrder && data.multiplyVariations" class='pp-button-blue--border' :disabled='cartQuantity == 0 ||  (this.data.variablePrices.length > 0 && !isVariableItemSelected)'
                    @click="addToCart('update')">
                    <span style="font-weight: 500;">{{ $t('common.addToCart') }}</span>
                  </button>
                
                  <div
                    @click="() => (changeVariant = false)"
                    class="buy-button__default text-white"
                    :style="'background-color:' + data.buyButtonStyle"
                    :disabled="(this.data.variablePrices.length > 0 && !isVariableItemSelected) || (data.multiplyVariations && !data.cartOrder && this.isAnyVariantwithQtyOne.length < 1)"  
                    :class="(this.data.variablePrices.length > 0 && !isVariableItemSelected) || (data.multiplyVariations && !data.cartOrder && this.isAnyVariantwithQtyOne.length < 1) ? 'buy-button__default--disabled' :''"
                  >
                    <span style="font-weight: 500;">
                      {{
                        data.chooseVariantButtonStyleSameAsBuy
                          ? data.buyButtonText
                          : (data.chooseVariantButtonText || "Pilih Varian")
                      }}
                    </span>
                  </div>
                </div>
                <div class="bottom-sheet__footer">
                  <div />
                </div>
                <transition name="fade" v-on:enter="showMsg">
                  <div  v-if="show" class="variant-modal__alert">
                    <div class="variant-modal__alert__content">
                      <img src="@/assets/icons/grey-tick.svg" alt="" />
                      <div>{{ $t('common.itemAddedToCart') }}</div>
                    </div>
                  </div>
                </transition>
              </div>
            </vs-dialog>

            <!-- ORDER SUMMARY MOBILE-->
            <vs-dialog overflow-hidden class="pp-modal-vuesax variant-modal modal-order-summary--mobile" v-model="cartOrderSummary">
              <div class="pp-modal-vuesax__container">
                <div class="pp-modal-vuesax__header">
                    <img class="icon-black"  src="@/assets/icons/Cart-bucket.png" alt="" />
                    <h4 class="modal-title">{{ $t('common.yourCart') }}</h4>
                </div>
                <hr>
                <div class="pp-modal-vuesax__main">
                  <div class="pp-order-summary cart-summary">
                      <!-- ORDER SUMMARY LIST -->
                    <div class="pp-order-summary__list__item pp-order-summary__list__item--variant-order">
                      <div class="common-font product-name product-title-shrink-checkout mb-15">
                        {{ data.name }}
                      </div>
                      <template v-for="(elem, i) in cartSummary">
                      <div v-if="elem" class="order-summary-list" v-bind:key="i + 'cartSummary'">
                        <div class="d-flex justify-between">
                          <div class="d-flex justify-between align-left m-1">
                            <div>({{ elem.qty }}x)</div>
                            <div class="text-left">
                              <div class="ml-1 overflow-wrap--anywhere" v-for="(elemChild, j) in elem.items" v-bind:key="j">
                                {{ j.substring(0, j.length - 1) }} : {{ elemChild.name }}
                              </div>
                            </div>
                          </div>
                          <div class="cartSummary-price">
                            <div v-if="elem.priceOriginal">
                              <div style="text-align: end;">
                                <div>Rp{{ getCartSubPrice(elem) | g_number_format }}</div>
                                <div v-if="getCartSubPrice(elem) !== elem.priceOriginal * elem.qty" class="text-danger" style="text-decoration: line-through;"> Rp{{elem.priceOriginal * elem.qty | g_number_format}}</div>
                              </div>
                            </div>


                          </div>
                          <!-- <div class="cart-price">
                            <div>Rp {{( elem.price * elem.qty) | g_number_format }}</div>
                          </div> -->
                        </div>

                        <div style="text-align: end;" @click="removeFromCart(i)">
                          <img class="light mr-1 removeFromCart" src="@/assets/icons/Delete-grey.svg" alt="" />
                        </div>
                      </div>
                      </template>
                    </div>

                    <!-- TOTAL -->
                    <div class="pp-order-summary__total">
                      <p class="pp-order-summary__total__label">{{ $t('common.total') }}</p>
                      <p class="pp-order-summary__total__number">
                        Rp
                        {{
                          cartSummary.reduce((a, b) => a + getCartSubPrice(b), 0) | g_number_format
                        }}
                      </p>
                    </div>
                  </div>
                </div>
                <div class="pp-modal-vuesax__footer pp-modal-vuesax__footer-full-width--mobile">
                  <div
                    @click="() => (changeVariant = false)"
                    class="buy-button__default text-white"
                    :style="'background-color:' + data.buyButtonStyle"
                  >
                    <span>{{ $t('common.continueOrder') }}</span>
                  </div>
                </div>
              </div>
            </vs-dialog>
          </no-ssr>
        </div>
      </div>
      
    </div>

    <!-- Modal popup for setting confrimation -->
    <!-- <div class="overlay" id="overlay" v-if="confirmBox">
      <div class="confirm-box">      
        <h2>Confirmation</h2>
        <p>{{settingRedirectMessage}}</p>
        <div class="flex justify-center">
         <button class="pp-button-blue--fill" @click="goNext()">Yes</button>    
        </div>
      </div>
    </div> -->
     <no-ssr>
      <div>
        <vs-dialog v-model="confirmBox" class="pp-modal-vuesax pp-modal-vuesax--default" :overflow-hidden="true" :prevent-close="true">
          <div class="pp-modal-vuesax__container">
            <div class="pp-modal-vuesax__main">
              <h2>{{ $t('common.confirmation') }}</h2>
              <p>{{settingRedirectMessage}}</p>
              <div class="flex justify-center">
                <button class="pp-button-blue--fill" @click="goNext()">{{ $t('common.yes') }}</button>    
              </div>
            </div>
          </div>
        </vs-dialog>   
        <div v-if="scripts.length">
          <div v-bind:key="index + 'index'" v-for="(pixel, index) of scripts">
            <!-- Google Tag Manager (noscript) -->
            <iframe v-if="pixel.type == 'gtm'" :src="'https://www.googletagmanager.com/ns.html?id=' + pixel.name" height="0"
              width="0" style="display:none;visibility:hidden"></iframe>
            <!-- End Google Tag Manager (noscript) -->
            <VueScriptComponent :script="pixel.script" />
          </div>
        </div>

        <!-- POP UP EMAIL CONFIRMATION FOR PRODUCT DIGITAL-->
        <vs-dialog class="pop-up-email-confirmation" width="460px" height="332px" v-model="emailConfirmModal">
          <div v-if="emailConfirmModal" class="main-content-email-confirm">

            <div class="header">
              <label class="title">{{ $t("digitalProduct.popUpEmailConfirmation.title") }}</label>
              <label class="subtitle">{{ $t("digitalProduct.popUpEmailConfirmation.subtitle") }}</label>
            </div>

            <hr class="m-0" />

            <div class="form-email">
              <label class="label-email">{{ $t("digitalProduct.popUpEmailConfirmation.input-label") }}</label>
              <vs-input
                class="input-email"
                :class="{'is-invalid': $v.inputEmailConfirm.$invalid && $v.inputEmailConfirm.$dirty}"
                type="email"
                :placeholder="$t('digitalProduct.popUpEmailConfirmation.input-placeholder')"
                v-model="inputEmailConfirm"
                @input="$v.inputEmailConfirm.$touch()"
              />

              <div
                v-if="$v.inputEmailConfirm.$dirty && !$v.inputEmailConfirm.required"
                class="invalid-email"
              >
                {{ $t("validation.emailIsRequired") }}
              </div>
              <div
                v-else-if="
                  $v.inputEmailConfirm.$dirty &&
                  $v.inputEmailConfirm.required &&
                  !$v.inputEmailConfirm.isValidEmail
                "
                class="invalid-email"
              >
                {{ $t("validation.emailIsNotValid") }}
              </div>
            </div>

            <div class="instruction">
              <img class="info" src="@/assets/icons/info.svg" />
              <label class="label">{{ $t("digitalProduct.popUpEmailConfirmation.instruction") }}</label>
            </div>

            <div class="button-container">
              <button class="confirm-button"
              :class="{
                'save': !$v.inputEmailConfirm.$invalid,
                'disabled': $v.inputEmailConfirm.$invalid,
              }"
              @click="onSubmittedPopUpEmailConfirm()" :disabled="$v.inputEmailConfirm.$invalid">Kirim</button>
            </div>
          </div>
        </vs-dialog>
      </div>
    </no-ssr>
  </div>
 
</template>

<script>

import config from './../../config.js'
import Seal from './seal.vue';
import Bottom from './bottom.vue';
import Right from './right.vue';
import Left from './left.vue';
import HeaderImage from '../HeaderImage.vue';
import Tuktuk from './Tuktuk/index.vue';
import SwitchGreenSelected from './../SwitchGreenSelected.vue';
import { getSizedImageUrl } from "@/helpers/imagekitHelper";
import { getWhatsAppUrl } from '@/helpers';
import axios from 'axios'
// import VueScriptComponent from 'vue-script-component'
import debounce from "lodash/debounce";
import Vue from 'vue'
import {getfbpc} from "../../helpers/getfbpc"
import {getContentId, getContentIds} from '../../helpers/contentIdHelper'
import { createHmac } from "crypto";
const secret = config.orderHmacSecret;
import NoSidebarNarrowCanvas from './template-type/no-sidebar-narrow-canvas';
import { required, email } from 'vuelidate/lib/validators';
import { get } from 'lodash';

import { createTrackingScripts } from '@/util/trackings';
import { cloneDeep } from 'lodash';
import { paymentFeeMethodName, calculateEpayFee, isOrderBelowEpayFee as checkIsOrderBelowEpayFee } from "@/helpers/epayMethodHelper";
import { AUTOFILL_SOURCE, AUTOFILL_EVENT, saveAutofillSource, getAutofillSource, getFilledFieldNames, toggleSaveDataChecked, isSaveDataChecked } from "@/helpers/checkoutAutofillHelper";
import {
  isDisplayableShippingEstimate,
  isUnavailableAutomatedShipping,
  isInactiveShippingCourier,
  UNREACHABLE_SHIPPING_ADDRESS_MESSAGE,
  SHIPPING_ESTIMATE_TIMEOUT,
  requestShippingEstimate
} from '@/data/shippingInit';

// Register vee-validate for supporting embed
import '../../../plugins/vee-validate.js'

import { ClassicTheme } from '@formulir/components-checkout'

export default {
  props: ['data','dataProductImages', 'form', 'isIOS', 'refresh', 'user', 'popup', 'belongs_to', 'checkout_id', 'domain', 'checkout_data', 'customWidth', 'mobileVersion', 'embed', 'refid', 'shippingCourierTypes', 'shippingCourierItems','shippingCourierTypesCargo', 'shippingCourierItemsCargo','setting'],
  inject: ["affiliate"],
  data() {
    return {
      config,
      discountLists:[],
      automaticDiscountLists:[],
      totalQuantity:0,
      confirmBox:false,
      settingRedirectMessage: this.$t('common.redirectedToForm'),//"By proceeding, you will get redirected to your checkout form",
      baseUrl: config.api.replace('/api', ''),
      DESTINATION_CODE: '',
      delivery: {
        jne: [],
        sicepat: [],
        sap: [],
        iDexpress: [],
        jNt: [],
        lion: [],
        JNECargo: [],
        SiCepatCargo: [],
        SapCargo: [],
        iDexpressCargo: [],
      },
      deliveryCourierPrice: "",
      loadingPrice: false,
      isBuyButtonLoading: false,
      orderCreated: false,
      doRedirect: true,
      errors: {},
      submited: false,
      payload: {
        deliveryPrice: 0,
        deliveryCourier: 'jne',
        deliveryType: 'REG',
        address: null,
        variablePrices: {},
        variablePricesValues: {},
        payment: undefined,
        // declared upfront so $set in autoSelectPayment doesn't add a new key and re-trigger the deep payload.variablePrices watcher
        _paymentSelectedByBuyer: false,
        bump: false,
        test: "test",
        dontIncludeSubdistrict: true,
        dontIncludeZipcode: true,
        VAT : { 
          value: 11, 
          amount :0,
          isVAT: false,       
        },
        sellerOriginId:'',
        discounts: [],
        automaticDiscount:{
          code:"",
          amount:0        
        }    
      },
      scripts: [],    
      total_price: 0,
      totalPrice: 0,
      VATPrice:0,
      price: 0,
      priceWithoutWhosale: 0,
      product_name: '',
      product_category_full: '',
      id: '',
      changeVariant: false,
      cartOrderSummary: false,
      cartSummary: [],
      show: false,
      cartQuantity: 1,
      cartTotal: 0,
      showCaptcha: false,
      repeatedOrderCount: 0,
      lastAssignee: undefined,
      selectedbumpArray: [],
      totalBumpOrderPrice: 0,
      isInvalid: false,
      isArchivedOrder: false,
      trackConversion: false,
      trackConversionApiCalled: false,
      isShowVariantImage: false,
      courierOptionDataCargo:[],
      courierOptionDataFinal:[],
      shippingDiscountValue:0,
      selectedAttributes:{},
      filterAttributes:{},
      isVariableItemSelected:false,
      productImages: cloneDeep(this.dataProductImages),
      variantImageIndex: -1,
      chosenData: {},
      cartMessage:"",
      isAnyVariantwithQtyOne: [],
      getSizedImageUrl,
      getfbpc,
      getContentId,
      handleAutofill:()=>{},
      autofillSource: AUTOFILL_SOURCE.NONE,
      isComponentReady: false,
      emailConfirmModal: false,
      inputEmailConfirm: '',
      calculateEpayFee,
      paymentFeeMethodName,
      checkIsOrderBelowEpayFee,
      isInvalidCustomerPhone: '',
      allEstimatePublic: {},
      selectedAddresses: {
        selectedProvince: '',
        selectedCity: '',
        selectedDistrict: '',
        selectedSubDistrict: '',
      },
      cancelTokenSource: null,
      shippingEstimateRequestId: 0,
      shippingEstimateCancelSource: null,
    }
  },
  validations() {
    return {
      inputEmailConfirm: {
        required,
        isValidEmail: email,
      },
    };
  },
  components: {
    "Right": Right,
    "Left": Left,
    "Bottom": Bottom,
    Seal,
    // VueScriptComponent,
    HeaderImage,
    Tuktuk,
    "selected-green-switch": SwitchGreenSelected,
    NoSidebarNarrowCanvas,
    ClassicTheme,
    // Carousel
  },
  filters: {
    // year_format(val) {
    //   return moment(val).format('YYYY')
    // },
  },
  methods: {
    resetInvalidPhone() {
      this.isInvalidCustomerPhone = ''
      this.errors['phone'] = ''
    },
    setSelectedAddresses(address) {
      this.selectedAddresses = {
        ...this.selectedAddresses,
        ...address,
      }
    },
    async getDiscountLists(code='') {   
      const params={
        offset:new Date().getTimezoneOffset(),
        user_id:this.data.user_id,
        size:5,
        page:1,
        type:'all',
        getAllData: true,
      }  
      if(code!=''){
        params['discount_code']=code
        params['includeHiden']=true
        params['product_type'] = this.data.productType;
      }
      const response = await axios.get(config.api +"product/discountList/"+this.data._id,{params});    
      if (response.data.success && response.data.data && response.data.data.length > 0) {
        this.discountLists = response.data.data.filter(d=>d.discount_value.applies_to.type=='spcific_products' && d.discount_value.applies_to.products.length > 0 ? d.discount_value.applies_to.products.indexOf(this.data._id) > -1 : true);
        if(code!=''){
          // apply coupon code directly by copied coupon link
          this.applyDiscount(this.data.discount_code);
        }
        
     
      }else{
        this.discountLists =[];
      }    
    },
     async getAutomaticDiscountLists() {      
      const response = await axios.get(config.api +"product/automaticDiscountsList/"+this.data._id+"?offset="+new Date().getTimezoneOffset()+"&user_id="+this.data.user_id+"&product_type="+this.data.productType);        
  
      if (response.data.success && response.data.data && response.data.data.length > 0) {
        this.automaticDiscountLists = response.data.data.filter(d => d.product_type === this.data.productType && d.discount_value.applies_to.type=='spcific_products' && d.discount_value.applies_to.products.length > 0 ? d.discount_value.applies_to.products.indexOf(this.data._id) > -1 : true);
      }else{
        this.automaticDiscountLists =[];
      }   
      
      if(this.data.showCoupon) {
        this.applyAutmaticDiscount();      
      }
    },
    uniqueById(arr, key){
      const seen = new Set();
      return arr.filter(item => {
        const value = item[key];
        if (seen.has(value)) {
          return false;
        } else {
          seen.add(value);
          return true;
        }
      });
    },
    updateDiscountLists(discounts,replace=false){
      if(replace){
        this.discountLists =[...discounts];
      }else{
        this.discountLists =[...this.discountLists,...discounts];
      }
      
      this.discountLists=this.uniqueById(this.discountLists, 'title')    
      
    },
    clearDiscount(code){
      this.payload.discounts = [ ...this.payload.discounts.filter(dc => dc.code !== code)];
      this.updatePrices();
      this.$forceUpdate();  
    },
    async applyDiscount(code) {
     // let self=this;
      if (code === '') {
        return
      }
       
      if(code){
        if (this.payload.discounts.some(d => d.code === code)) {
          this.$vs.notification({
            icon: `<i class='icon-info'></i>`,
            color: "danger",
            position: "top-right",
            text: this.$t("coupon.couponAlreadyClaimed"),
            duration: 2000,
          });

          return
        }

        this.resetPrices(); 
        const discount=this.discountLists.find(x=>x.title==code);

        if (!discount) {
          this.$vs.notification({
            icon: `<i class='icon-info'></i>`,
            color: "danger",
            position: "top-right",
            text: `Discount with code "${code}" not found.`,
            duration: 2000,
          });

          return;
        }

        if (discount.is_exclusive) {
          this.payload.discounts = [];
        }

        if (this.payload.discounts && this.payload.discounts.length) {
          const exclusiveDiscount = this.payload.discounts.find(dc => dc.is_exclusive);

          if (exclusiveDiscount) {
            this.$vs.notification({
              icon: `<i class='icon-info'></i>`,
              color: "danger",
              position: "top-right",
              text: "Applied exclusive coupon can't be stacked with other coupons.",
              duration: 2000,
            });

            return;
          }
        }
        const applied_discount=this.getApplyDiscount(discount);  
        if(!isNaN(applied_discount.discount_amount)){
          const selectedDiscount = {
            code,
            amount: applied_discount.discount_amount,
            discount_type: discount.discount_type,
            discount_value: discount.discount_value,
            minimum_requirements: discount.minimum_requirements,
            end_date: discount.end_date,
            full_end_date: discount.full_end_date,
            full_start_date: discount.full_start_date,
            is_exclusive: discount.is_exclusive,
          };

          this.payload.discounts.push(selectedDiscount);
          this.$forceUpdate();     
        }else{
          this.$vs.notification({
            icon: `<i class='icon-info'></i>`,
            color: "danger",
            position: "top-right",
            text: get(applied_discount, 'message.length') ? get(applied_discount, 'message') : "Applied coupon does not meet the minimum requirements",
            duration: 2000,
          });   
        }       

        for (const selectedDiscount of this.payload.discounts) {
          const newPrice = this.totalPrice - selectedDiscount.amount;
          this.totalPrice = Math.max(0, newPrice);
        }

        this.calcEpayFee()

        if (this.data && this.data.VAT && this.data.VAT.isVAT) {
          this.applyVATPercentage()
        }
      }
    },
    shouldRender(component) {
      if (!this.mobileVersion) return true;

      if (['requestedFields', 'buyButton'].includes(component.name)) return true;
      if (['guaranteeSeal'].includes(component.name)) return false;

      if (component.name === 'shipping') {
        return this.data.addShipping &&
          (this.payload.payment === 'COD' ? this.data.shippingCOD.shippingType === 'automated' : this.data.shippingType === 'automated') &&
          this.payload.address &&
          this.courierOptionDataFinal &&
          this.courierOptionDataFinal.length > 0 &&
          (this.courierOptionDataFinal.length > 1 ||
            (this.courierOptionDataFinal.length == 1 && !this.shippingHideView))
      }

      // based on toggle v-model show hide component, search div with class right-adjust-positions
      return this.data && this.data[component.buttonVar]
    },
    applyAutmaticDiscount(){
      if(this.automaticDiscountLists.length>0){
        const choosenDiscount = this.automaticDiscountLists.map(discount=>{
          const applied_discount=this.getApplyDiscount(discount); 
          discount["amount"]=applied_discount ? applied_discount.discount_amount: NaN;
          return discount;
        });
        let maxDiscount = choosenDiscount.filter(discount => !isNaN(discount.amount)).reduce((prev, current) => (prev.amount > current.amount) ? prev : current, NaN);
        if(this.shouldRecalculateAutomaticDiscount && !isNaN(maxDiscount.amount) && this.totalPrice > maxDiscount.amount){
          this.payload.automaticDiscount["amount"]=maxDiscount.amount;    
          this.payload.automaticDiscount["code"]=maxDiscount.title;         
          this.totalPrice=this.totalPrice-maxDiscount.amount        
          this.payload.automaticDiscount["discount_type"]=maxDiscount.discount_type;  
          this.payload.automaticDiscount["discount_value"]=maxDiscount.discount_value;  
          this.payload.automaticDiscount["minimum_requirements"]=maxDiscount.minimum_requirements; 
          this.payload.automaticDiscount["end_date"]=maxDiscount.end_date; 
          this.payload.automaticDiscount["full_end_date"]=maxDiscount.full_end_date; 
          this.payload.automaticDiscount["full_start_date"]=maxDiscount.full_start_date;          
          this.$forceUpdate();  
        }else{
          this.payload.automaticDiscount["amount"]=0;        
          this.payload.automaticDiscount["code"]="";   
         }  
        }    
    },
    getApplyDiscount(discount){
      const result = {
        discount_amount: 0,
        message: '',
      };

      let totalQuantity=this.totalQuantity;
        if(this.cartSummary.length > 0){
          totalQuantity=0;
          this.cartSummary.map(async (e) => {      
          totalQuantity = totalQuantity + e.qty;
        });
      }        

      if (discount.product_type !== this.data.productType) {
        return {
          ...result,
          discount_amount: NaN,
        };
      }

      if(discount.minimum_requirements.type=='minimum_purchase'){      
        if(Number(discount.minimum_requirements.value)>this.totalPrice){         
          return {
          ...result,
          discount_amount: NaN,
        };
        }
        
      }else if(discount.minimum_requirements.type=='minimum_quantity'){           
        if(Number(discount.minimum_requirements.value)>totalQuantity){        
          return {
          ...result,
          discount_amount: NaN,
        };
        }  
       
      } 

      if (discount.payment_type && discount.payment_type !== 'both') {
        const isCOD = this.payload.payment === 'COD';
        if (
          (discount.payment_type === 'cod' && !isCOD) ||
          (discount.payment_type === 'non_cod' && isCOD)
        ) {
          return {
          ...result,
          discount_amount: NaN,
        };
        }
      }

      if(discount.discount_type=="moneyOffProduct"){
        let price =  this.price;      
        if(this.cartSummary.length > 0){
          price = 0;
          this.cartSummary.map((e) => {
              if (!e) return;
              let subPrice = (e.price ? e.price : e.priceOriginal) * e.qty;
              if (e.whosaleData) {
                e.whosaleData.map((one) => {
                  if (one.count && parseInt(one.count) <= parseInt(e.qty)) {
                    subPrice = one.price * parseInt(e.qty);
                  }
                });
              }
              price = price + subPrice;
            })
        }    

         
         
          if(discount.discount_value.type=="fixed"){                   
            result.discount_amount=Number(discount.discount_value.value);           
          }else{
            result.discount_amount =(price *Number(discount.discount_value.value)) / 100;                                      
                           
          }       
          
        }else if(discount.discount_type=="moneyOffOrder"){
          if(discount.discount_value.type=="fixed"){                   
            result.discount_amount=Number(discount.discount_value.value);         
          }else{
           
            let totalPrice=this.totalPrice
            if(this.payload.automaticDiscount["amount"] && this.payload.automaticDiscount["amount"] > 0){
              totalPrice=this.totalPrice+this.payload.automaticDiscount["amount"];
            }
            result.discount_amount =(totalPrice *Number(discount.discount_value.value)) / 100;                            
                    
          }  
        }else if(discount.discount_type=="moneyOffShipping"){
          const addressForm = this.data.requestedFields.find(reqField => reqField.field === 'address');
          if (!this.data.addShipping || !addressForm) {
            return {
              ...result,
              message: 'Kupon ongkir tidak bisa dipakai dikarenakan form address dan pengiriman tidak diaktifkan untuk produk ini!',
            };
          }

          const isCOD = this.payload.payment === "COD";
          const shippingData = isCOD && this.data.isPaymentTypeHaveDifferentValue ? this.data.shippingCOD : this.data;

          // Extract relevant values with default fallbacks
          const shippingType = shippingData.shippingType;
          const flatShippingPrice = shippingType === "flat" ? Number(shippingData.flatShippingPrice || 0) : 0;
          const canApplyAdditionalCost = shippingType !== "automated" || this.payload.address;
          const additionalCost = canApplyAdditionalCost ? Number(shippingData.additionalCost || 0) : 0;
          const shippingDiscountType = get(shippingData.shippingDiscount, "type", "fixed");
          const shippingDiscountValue = shippingType === "automated" && this.payload.address && get(shippingData.shippingDiscount, 'status', false) ? Number(shippingData.shippingDiscount.value || 0) : 0;

          // Determine shipping price
          const shippingPrice = shippingType === "free" 
            ? 0 
            : shippingType === "flat" 
              ? flatShippingPrice 
              : Number(this.payload.deliveryPrice || 0);

          // Compute discount amount
          const shippingDiscountAmount = shippingType === "automated" ? (shippingDiscountType === "fixed" 
            ? shippingDiscountValue 
            : (shippingPrice * shippingDiscountValue) / 100)
            : 0;

          // Final delivery price calculation
          const deliveryPrice = Math.max(0, shippingPrice + additionalCost - shippingDiscountAmount);
          const remainingQuotaAmount = this.shippingCouponAmountValidation(deliveryPrice, shippingType);

          if (remainingQuotaAmount === 0) {
            const isAutomatedWithoutAddress = shippingType === "automated" && !this.payload.address;
            if (isAutomatedWithoutAddress) return result;

            return {
              discount_amount: NaN,
              message: "Kupon ongkir sudah mencapai batas maksimal dan tidak dapat digunakan lagi.",
            };
          }

          if (deliveryPrice) {
            if (discount.discount_value.applies_to.type === 'spcific_products') {
              if (!discount.discount_value.applies_to.products.includes(this.data.product_id)) {
                return {
                  ...result,
                  discount_amount: NaN,
                };
              }
            }

            if (discount.discount_value.applies_to.shipping_type=='all' || discount.discount_value.applies_to.shipping_type==this.payload.deliveryCourier) {
              if (discount.discount_value.type=="fixed"){                   
                result.discount_amount=Number(discount.discount_value.value);         
              } else{
                result.discount_amount =(deliveryPrice *Number(discount.discount_value.value)) / 100;    
              }

              if (result.discount_amount > remainingQuotaAmount) {
                result.discount_amount = remainingQuotaAmount;
              }
            } else {
              return {
                ...result,
                discount_amount: NaN,
              };
            }
          }
        }
        result.discount_amount=Math.round(result.discount_amount) 
        return result;

    },  
    saveDataForNexttime(source = AUTOFILL_SOURCE.SAVE_DATA) {
      // TODO: revisit logic save data for next time
      let subdomain = window.location.hostname;
      let customerInfoArr = {};
      let customerAddrArr = {};
      if (this.data.requestedFields && subdomain) {
        customerInfoArr[subdomain] = this.data.requestedFields;
        localStorage.setItem(
          "CheckoutCustomerInfo",
          JSON.stringify(customerInfoArr)
        );
      }
      if (this.payload.address != null) {
        customerAddrArr[subdomain] = this.payload.address;
        localStorage.setItem(
          "CheckoutAddressInfo",
          JSON.stringify(customerAddrArr)
        );
      }
      saveAutofillSource(subdomain, source);
    },
    // The classic theme's "save" checkbox saves right away, ticked or not, as before.
    onSaveDataCheckbox() {
      toggleSaveDataChecked();
      this.saveDataForNexttime();
    },
    // The seller's automatic save (Simpan Data Pembeli without the checkbox) runs on submit. FW-3293 also
    // saves for a whitelisted seller; that is saveDataHidden unless the buyer ticked "save" on this page.
    saveDataOnSubmit() {
      const isSellerAutoSave = this.data.saveInfoWithoutEnable && this.data.isSaveInfoNextTime;
      if (isSellerAutoSave || (this.isAutoFillForm && isSaveDataChecked())) {
        this.saveDataForNexttime(AUTOFILL_SOURCE.SAVE_DATA);
      } else if (this.isAutoFillForm) {
        this.saveDataForNexttime(AUTOFILL_SOURCE.SAVE_DATA_HIDDEN);
        this.trackAutofillEvent({ event: AUTOFILL_EVENT.SAVE_DATA_HIDDEN_STORED });
      }
    },
    // [FW-3982] Analytics only: the checkout never waits for it and ignores its failure.
    trackAutofillEvent(event) {
      axios.post(config.api + 'order/checkout/autofill-event', {
        ...event,
        productId: this.data._id,
        formId: this.data.form_id,
        checkoutId: this.checkout_id || undefined
      }).catch(() => {});
    },
    getImageSrc(attr){ 
      let imageUrl;  
      let variantImageIndex;    
      if(attr && attr.attrs) {
        variantImageIndex = this.data.variablePrices && this.data.variablePrices.findIndex(
          (x) => x.name  && x.image && x.name.indexOf(attr.attrs[0].value+" / ") > -1
        );
      }          
      if(attr.image){       
        imageUrl= getSizedImageUrl(attr.image,'medium','product-images')
      } 
      else if (variantImageIndex > -1 && this.data.variablePrices && this.data.variablePrices[variantImageIndex].image ){       
        imageUrl= getSizedImageUrl(this.data.variablePrices[variantImageIndex].image,'medium','product-images'); 
      } 
      else if (this.productImages.length>0 ){       
        imageUrl= getSizedImageUrl(this.productImages[0].src,'medium','product-images'); 
      }else if(this.variantImageIndex > -1){
        imageUrl= getSizedImageUrl(this.productImages[this.variantImageIndex].image,'medium','product-images'); 
      }            
      return imageUrl;
    },
    getSKU(param){
      for(let i =0; i < param.length;i++){
        if(param[i].SKU && param[i].SKU != ""){
          return param[i];
        }
      }
    },
    isHasOneWordLongText (text, maxLength=10){
      const words = text.split(' ');
      const result = words.some(word => {
          return word.length >= maxLength;
      });
      return result;
    },
    showChoosenData(){
      let selectedVariant = this.getSelectedVariantName(this.payload.variablePrices)
      let priceVar = this.data.variablePrices.filter(
        (e) => e.name == selectedVariant
      );
      if(priceVar){
        this.chosenData = priceVar[0];
      }
    },
    updateProductImages() {  
      let itemName = [];
      Object.keys(this.payload.variablePrices).map((key) => {
        itemName.push(this.payload.variablePrices[key].name);
      });
      this.variantImageIndex = this.productImages.findIndex(
        (x) => x.name == itemName.join(" / ")
      );
    
      if(this.variantImageIndex==-1){
        this.variantImageIndex = this.productImages.findIndex(
          (x) => x.name && x.name.indexOf(itemName[0]+" / ") > -1
        );
      }
      if(this.variantImageIndex==-1 && this.productImages.length>0){
        this.variantImageIndex =0;
      }
    },
    checkOption(name,attrval){    
     return !this.filterAttributes[name+"_"+attrval]
    },
    async submitted() {
      try {
        this.isBuyButtonLoading = true
        this.submited = true;
        await this.validate();
        if (Object.keys(this.errors).length) {
          const inputErrors = document.getElementsByClassName('scroll-to-error-message');
          inputErrors[0] && inputErrors[0].scrollIntoView({ behavior: 'smooth' })

          this.$vs.notification({
            icon: `<i class='icon-info'></i>`,
            color: "danger",
            position: "top-right",
            text: this.$t('validation.pleaseFix'),//"Please fix fields error before proceeding to next step",
            duration: 2000,
          });
          this.isBuyButtonLoading = false
          return;
        }

        if (this.isOrderBelowEpayFee()) {
          this.isBuyButtonLoading = false;
          this.submited = false;
          return;
        }

        // No listed courier reaches the address: "Pesanan diproses" takes the order without
        // a courier (FW-3925), "Pesanan tidak diproses" keeps it from checking out.
        if (this.isShippingAddressUnreachable && !this.data.isShippingCoverageCanOrder) {
          this.$vs.notification({
            icon: `<i class='icon-info'></i>`,
            color: "danger",
            position: "top-right",
            text: UNREACHABLE_SHIPPING_ADDRESS_MESSAGE,
            duration: 3000,
          });
          this.isBuyButtonLoading = false;
          this.submited = false;
          return;
        }

        if (get(this.data, 'productType') === 'digital' && get(this.data, 'digitalProduct.isBuyerEmailConfirmationEnabled', false)) {
          this.emailConfirmModal = true;
          this.isBuyButtonLoading = false
          return;
        }

        this.saveDataOnSubmit();
        this.save();
      } catch (e) {
        this.isBuyButtonLoading = false
        this.submited = false;
      }
    },
    isOrderBelowEpayFee() {
      // Toast stays here to match the form's Vuesax convention; check delegates out.
      const args = {
        data: this.data,
        payload: this.payload,
        totalPrice: parseInt(this.totalPrice, 10),
        cartTotal: parseInt(this.cartTotal, 10),
        formPrice: parseInt(this.price, 10),
      };
      const blocked = checkIsOrderBelowEpayFee(args);
      if (!blocked) return false;

      const ePaymentMethods = ['bca_va', 'bni_va', 'echannel', 'bri_va'];
      const isEPayment = ePaymentMethods.includes(this.payload.payment);
      
      const notificationText = isEPayment 
        ? 'Transaksi di bawah Rp4.440 tidak dapat diproses dengan metode ini. Silakan ubah metode pembayaran atau hubungi penjual.'
        : 'Minimal order tidak terpenuhi';

      this.$vs.notification({
        icon: `<i class='icon-info icon-order-below-epay-fee'></i>`,
        color: 'danger',
        position: 'top-right',
        text: notificationText,
        duration: 5000,
        buttonClose: false,
        classNotification: 'vuesax-notification',
      });
      return true;
    },
    async validate() {
      if (!this.submited) {
        return;
      }
      if (this.$refs.form) {
        const success = await this.$refs.form.validate();
        if (!success) {
          const inputErrors = document.getElementsByClassName('scroll-to-error-message');
          inputErrors[0] && inputErrors[0].scrollIntoView({ behavior: 'smooth' })
          
          this.$vs.notification({
            icon: `<i class='icon-info'></i>`,
            color: "danger",
            position: "top-right",
            text: this.$t('validation.pleaseFix'),
            duration: 2000,
          });

          throw new Error('invalid-form');
        }
      }
      let isActiveMinimumPurchase = false;
      let minimumPurchase = 1;
      this.errors = {};
      let requestedFields = this.data.requestedFields.filter(
        (one) => one.active
      );
      if (this.data.isActiveMinimumPurchase) {
        isActiveMinimumPurchase = true;
        minimumPurchase = this.data.minimumPurchase;
      }
      let isFieldQuantityActive = false;
      const requestedFieldsLength=requestedFields.length;
      const addressFields = {
        PROVINCE_NAME: 'PROVINCE',
        CITY_NAME: 'CITY',
        DISTRICT_NAME: 'DISTRICT',
        SUBDISTRICT_NAME: 'SUBDISTRICT',
      };
      requestedFields.map((one,index) => {
        const addressField = one.field === 'address' && addressFields[one.key];
        if (addressField) {
          // Parent changes can leave row.value or the display label stale.
          // Validate the actual selected address, and only require mandatory fields.
          const value = this.payload.address && this.payload.address[addressField];
          if (one.required === 'yes' && (!value || !String(value).trim() || String(value).trim() === '-')) {
            this.errors[one.key] = this.$t("validation.mustBeFilled");
          }
          return;
        }
        if ((one.required == "yes" && !one.value) || (this.data.formMode == "Progressive Form" && ((!one.value && one.required == "yes" && requestedFieldsLength== index+1) || (!one.value && requestedFieldsLength!= index+1)))) {
          if (one.field == "phone") {
            this.errors[one.field] = this.$t("validation.mustBeFilledPhone");
          } else if (one.field == "email") {
            this.errors[one.field] = this.$t("validation.mustBeFilledEmail");
          } else if (one.field == "address") {
            if (!this.payload.address) { 
              this.errors[one.field] = this.$t("validation.mustBeFilled");
            }
          }else {
            this.errors[one.field] = this.$t("validation.mustBeFilled");
          }
        }
        if (one.field == "phone") {
          let value = one.value.toString();
          value = value.replace(/ /g, "");
          value = value.replace(/-/g, "");
          value = value.replace(/\(/g, "");
          value = value.replace(/\)/g, "");

          var phoneno =
            /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{1,4})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
          if (!(value ? !!value.match(phoneno) : true)) {
            this.errors[one.field] =  this.$t("validation.mustBeFilledPhone");
          }
        }
        if (one.field == "email" || one.inputType == "email") {
          const re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          if (one.value && !re.test(String(one.value).toLowerCase())) {
            this.errors[one.field] = this.$t("validation.mustBeFilledEmail");
          }
        }

        if (one.inputType == "url") {
          var pattern = new RegExp(
            "^(https?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.?)+[a-z]{2,}|" + // domain name
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
            "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
            "i"
          ); // fragment locator
          if (one.value && !pattern.test(one.value)) {
            this.errors[one.field] = "Invalid Value";
          }
        }
        if (one.field == "quantity") {
          if (isActiveMinimumPurchase) {
            if (!one.value) {
              this.errors[one.field] = this.$t("validation.mustBeFilled");
            }
            else if (one.value < minimumPurchase) {
              this.errors[one.field] = this.$t("validation.qtyMin").replaceAll('{x}', minimumPurchase);
              isFieldQuantityActive = true;
            }
          }
        }
      });
           
      // Add required for shipping method
      if(this.data.variationRequierd && this.varData && this.varData.length && !isUnavailableAutomatedShipping(this.data, this.payload.payment)) {
        this.errors['deliveryCouriePrice'] = this.$t("validation.selectExpedition"); //"Pilih Ekspedisi is required";
      }
      
      if ((this.data.variationRequierd || !isFieldQuantityActive) && this.data && this.data.enableProductOptions && this.data.variablePrices && this.data.variablePrices.length > 0) {
        const allQtyZero = this.data.variablePrices.every(item => item.qty === 0);
        // If all qty values are 0, throw an error
        if (allQtyZero) {
          this.errors["zeroQTY"] = this.$t("validation.qtyGTZero");
        }
        let message = "";
        if (this.data.cartOrder && localStorage.getItem("cartSummaryCheckout")) {
          let tempCookie = JSON.parse(localStorage.getItem("cartSummaryCheckout"));
          tempCookie.map((temp) => {
            this.data.variablePrices.map((varPrice) => {
              if (temp.name === varPrice.name) {
                let varPriceIsActiveMinimumPurchase = false;
                let varPriceMinimumPurchase = 1;
                if (varPrice.isActiveMinimumPurchase !== undefined && varPrice.isActiveMinimumPurchase) {
                  varPriceIsActiveMinimumPurchase = varPrice.isActiveMinimumPurchase;
                  varPriceMinimumPurchase = varPrice.minimumPurchase;
                }
                if (varPriceIsActiveMinimumPurchase) {
                  if (varPrice.qty > 0) {
                    if (varPrice.qty < varPriceMinimumPurchase) {
                      let variantAttr = varPrice.attrs[0].name.replaceAll("0", "");
                      message += this.$t("validation.qtyMinVariant").replaceAll("{variantAttr}", variantAttr).replaceAll("{variantName}", varPrice.name).replaceAll('{x}', varPriceMinimumPurchase) + ", ";
                    }
                  }
                }
              }
            });
          });
        }
        else {
          this.data.variablePrices.map((varPrice) => {
            varPrice['zeroQTY']=''
            let varPriceIsActiveMinimumPurchase = false;
            let varPriceMinimumPurchase = 1;
            if (varPrice.isActiveMinimumPurchase !== undefined && varPrice.isActiveMinimumPurchase) {
              varPriceIsActiveMinimumPurchase = varPrice.isActiveMinimumPurchase;
              varPriceMinimumPurchase = varPrice.minimumPurchase;
            }
            if (varPriceIsActiveMinimumPurchase) {
              if (varPrice.qty > 0) {
                if (varPrice.qty < varPriceMinimumPurchase) {
                  let variantAttr = varPrice.attrs[0].name.replaceAll("0", "");
                  if(!(this.data.multiplyVariations && !this.data.cartOrder)){
                    message += this.$t("validation.qtyMinVariant").replaceAll("{variantAttr}", variantAttr).replaceAll("{variantName}", varPrice.name).replaceAll('{x}', varPriceMinimumPurchase) + ", ";
                  }else{
                    this.errors["qtyMinVariant"] = this.$t("validation.qtyMin").replaceAll('{x}', varPriceMinimumPurchase);
                    message += this.$t("validation.qtyMinVariant").replaceAll("{variantAttr}", variantAttr).replaceAll("{variantName}", varPrice.name).replaceAll('{x}', varPriceMinimumPurchase) + ", ";
                  }                
                  varPrice['zeroQTY']=this.$t("validation.qtyMin").replaceAll('{x}', varPriceMinimumPurchase);                
                 
                }
              }
            }
          });
        }
        
        if (message){
          message = message.substring(0, message.length - 2);
          this.errors["zeroQTY"] = message;
        } 
      }

      // Add required for shipping method
      if(this.data.addShipping && this.data.shippingType == 'automated' && !isUnavailableAutomatedShipping(this.data, this.payload.payment) && this.payload.address && this.selectableShippingCouriers.length > 0 &&  (!this.payload.deliveryCourier || !this.payload.deliveryPrice || !this.payload.deliveryType)) {
        this.errors['deliveryCouriePrice'] = this.$t("validation.selectExpedition"); //"Pilih Ekspedisi is required";
      }

      return;
    },
    displayCopyright(index) {
      if (this.mobileVersion) {
        if (this.compfieldsPositionMobile.length - 1 == index) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    displayDiv(fieldName, divName) {
      if (this.mobileVersion) {
        if (fieldName == divName) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    // captcha settings for checkout page 
    async checkTrackingConversionOnce(order) {
      const compareTime = sessionStorage.getItem("compareTime");
      let orderItem = {}
      if (compareTime && !this.trackConversionApiCalled) {
        const productId = this.data._id
        orderItem = await axios.post(config.api + 'order/trackConversionOnce', { productId: productId, ip: this.data.ip, time: compareTime, product_id: order.product_id, customerName: order.customerName, customerPhone: order.customerPhone, order_id: order._id });
        this.trackConversionApiCalled = true;
        this.trackConversion = orderItem;
      }
      return this.trackConversionApiCalled ? this.trackConversion : orderItem; // Add 'return' statement to return the value of ordersCount
    },
    exit(event, self) {   
      let checkRedirectEnable=true;
      if("enableSettingRedirect" in self.data && self.data.enableSettingRedirect==false){
        checkRedirectEnable=false;
      }     
      if (checkRedirectEnable && self.data.settingRedirect && ((self.data.settingRedirect == 'url' && self.data.settingRedirectUrl !== '') || (self.data.settingRedirect == 'whatsappSeller' && self.data.settingRedirectWAnumber !== '') || (self.data.settingRedirect == 'whatsappSequence' && self.data.settingRedirectWAnumbers.length > 0)) && self.doRedirect) {
        event.preventDefault();
        setTimeout(async function () {
          if (self.data.settingRedirect == 'url') {
            // window.history.pushState("", "", "new url");
            // window.location.reload();
            // location.replace(self.data.settingRedirectUrl);
            window.top.location = self.data.settingRedirectUrl;
          } else {
            let number = self.data.settingRedirectWAnumber
            if (self.data.settingRedirect == 'whatsappSequence') {
              let r = await self.data.settingRedirectWAnumbers.findIndex(e => e.used);
              let index = r != -1 ? (r + 1 != self.data.settingRedirectWAnumbers.length ? r + 1 : 0) : 0
              number = self.data.settingRedirectWAnumbers[index].number;
              self.data.settingRedirectWAnumbers.map(e => { e.used = false });
              self.data.settingRedirectWAnumbers[index].used = true
              if (!self.popExecuted) {
                self.popExecuted = true;
                axios.post(config.api + "product/updateWASequence", {
                  _id: self.data._id,
                  payload: {
                    settingRedirectWAnumbers: self.data.settingRedirectWAnumbers
                  },
                });
              }
            }
            let url = getWhatsAppUrl(number);
            // location.replace(url);
            window.top.location = url;
          }
        }, 0);
        return;
      }
    },
    // async checkLast24HourProduct() {
    //    const productId = this.data._id
    //     let res = await axios.post(config.api + 'order/getLast24HourOrders', {productId: productId, ip: this.data.ip})
    //      if (res.data.success) {
    //         const orderData = res.data.orders
    //         if(orderData.length > 0) {
    //            this.repeatedOrderCount = orderData.length;
    //            this.lastAssignee = orderData[0].handledBy;
    //             if(orderData.length >= 5) {
    //               this.showCaptcha = true
    //             }
    //         } else {
    //            this.lastAssignee = undefined;
    //            this.repeatedOrderCount= 0;
    //            this.showCaptcha = false
    //         } 
    //      } else {
    //            this.lastAssignee = undefined;
    //            this.repeatedOrderCount= 0;
    //            this.showCaptcha = false
    //       }
    // },


    // captcha settings for checkout page
    async checkCaptchaOnProduct() {
      if (this.data.isCaptchaEnable) {
        const productId = this.data._id
        let res = await axios.post(config.api + 'order/getLast24HourOrders', { productId: productId, ip: this.data.ip, captchaSettings: this.data.captchaSettings })
        const orderData = res.data.orders
        if (res.data.success) {

          //Conditions to check captcha settings and enable captcha
          for (let objKey in this.data.captchaSettings) {
            const element = this.data.captchaSettings[objKey];
            if (element.isEnable) {
              if (element.type == 'setting1' && element.isEnable && element.orderCount <= orderData.setting1) {
                this.showCaptcha = true
              }
              if (element.type == 'setting2' && element.isEnable && element.orderCount <= orderData.setting2) {
                this.showCaptcha = true;
                this.isInvalid = true
              }
              if (element.type == 'setting3' && element.isEnable && element.orderCount <= orderData.setting3) {
                this.showCaptcha = true;
                this.isInvalid = true;
                // make order not archived if from abandoned checkout
                if (!(this.checkout_data.form_id)) this.isArchivedOrder = true
              }
            }
          }
        }
      }
    },
    populateCheckout() {
      if (this.checkout_data) {
        let cData = {};
        Object.keys(this.checkout_data).map(key => {
          if (key == 'customerName') {
            cData.name = this.checkout_data[key]
          } else if (key == 'customerPhone') {
            cData.phone = this.checkout_data[key]
          }
          else if (key == 'customerEmail') {
            cData.email = this.checkout_data[key]
          }
          else if (key == 'RECEIVER_ADDR') {
            cData.addressText = this.checkout_data[key]
          } else if (key == 'paymentInfo' && this.data.showPayment) {
            cData.payment = this.checkout_data[key];
            this.payload.payment = this.checkout_data[key];
          } else if (key == 'address') {
            this.payload.address = this.checkout_data[key];
          } else {
            cData[key] = this.checkout_data[key]
          }
        })
        this.data.requestedFields.map((attr) => {
          if (attr.field == 'subdistrict') {
            attr.value = cData[attr.field] ? cData[attr.field] : false
          } else {
            attr.value = cData[attr.field] ? cData[attr.field] : ''
          }
        })
      }
    },
    addCartItem(){
      this.show=!this.show;
    },
    getSelectedVariantQty() {
      if (this.data.multiplyVariations) return this.data.cartOrder ? 1 : 0;
      if (!this.data.addQuantity) return 1;
      const selectedQty = parseInt(this.cartQuantity);
      return selectedQty > 0 ? selectedQty : 1;
    },
    updateCartQuantity(val) {     
      this.cartQuantity = val;      
      if(this.data.type == 'simple'){
        const index=this.data.requestedFields.findIndex(x=>x.field=='quantity' && x.active);       
        if(index > -1){
          this.data.requestedFields[index].value=this.cartQuantity;
        }
      }else if(this.cartSummary.length==0 && this.data.multiplyVariations && this.data.cartOrder ){
        let selectedVariant = this.getSelectedVariantName(this.payload.variablePrices)
        let priceVar = this.data.variablePrices.filter(
          (e) => e.name == selectedVariant
        );      
        if (priceVar.length) {
          priceVar[0].qty =this.cartQuantity;
        }        
      }else if(!this.data.multiplyVariations && this.data.addQuantity){
        let selectedVariant = this.getSelectedVariantName(this.payload.variablePrices)
        let priceVar = this.data.variablePrices.filter(
          (e) => e.name == selectedVariant
        );      
        if (priceVar.length) {
          priceVar[0].qty =this.cartQuantity;
        }
      }    

      this.updatePrices();
      this.handleEstimate(true)
    },
    updateCartTotal(val) {
      this.cartTotal = val;
    },
    updateMobileView(data) {
      this.cartSummary = data;
      this.changeVariant = !this.changeVariant;
      let selectedVariant = this.getSelectedVariantName(this.payload.variablePrices)
      let priceVar = this.data.variablePrices.filter(
        (e) => e.name == selectedVariant
      );
      if (priceVar.length) {
        this.cartQuantity = priceVar[0].qty ? priceVar[0].qty : 1;
      }
      if (this.cartOrderSummary) {
        this.cartOrderSummary = false;
      }
    },
    getSelectedVariantName(param) {
      let selectedVariant = Object.values(param);
      selectedVariant = selectedVariant.map((data) => {
        return data.name;
      });
      return selectedVariant
        .toString()
        .replace(/[,]/g, " / ");
    },
    getCartSubPrice(item) {
      const qty = parseInt(item.qty || 0);
      if (!qty) return 0;

      let subPrice = item.price ? item.price : item.priceOriginal;
      if (item.whosaleData) {
        const wholesaleQty = this.data.multiplyVariations && this.data.cartOrder && this.cartSummary.length
          ? this.cartSummary.reduce((total, cartItem) => total + parseInt(cartItem.qty || 0), 0)
          : qty;
        item.whosaleData.map((one) => {
          if (one.count && parseInt(one.count) <= wholesaleQty) {
            subPrice = one.price;
          }
        });
      }

      return subPrice * qty;
    },
    addToCart(action = undefined) {
      this.show = !this.show;
      this.cartMessage=Object.keys(this.payload.variablePrices)
                    .map((o) => this.payload.variablePrices[o].name)
                    .join(" - ");
      let temp = [];
      if (localStorage.getItem("cartSummaryCheckout")) {
        temp = JSON.parse(localStorage.getItem("cartSummaryCheckout"));
      }
      if (temp.length == 0) { this.data.variablePrices.map(e => e.qty = 0) }
      let selectedVariant = this.getSelectedVariantName(this.payload.variablePrices)
      let priceVar = this.data.variablePrices.filter(
        (e) => e.name == selectedVariant
      );
      if (action == "update" || this.data.cartOrder) {
        if (priceVar.length) {
          priceVar[0].qty = this.data.addQuantity ? this.cartQuantity : (this.data.cartOrder && this.data.addQuantity) ? priceVar[0].qty + 1 : this.cartQuantity;
        }
      }
      let presentIndex = temp.findIndex(e => e.name == selectedVariant)
      if (presentIndex != -1) {
        // temp[presentIndex].quantity = temp[presentIndex].quantity + (priceVar.length ? priceVar[0].qty : 1);
        temp[presentIndex].qty = (priceVar.length ? priceVar[0].qty : 1);
        temp[presentIndex].whosaleData = priceVar.length && priceVar[0].whosaleData ? priceVar[0].whosaleData : undefined;

      } else {
        temp.push({
          name: selectedVariant,
          items: this.payload.variablePrices,
          priceOriginal: priceVar.length
            ? priceVar[0].price
              ? priceVar[0].price
              : 0
            : 0,
          price: priceVar.length
            ? priceVar[0].priceCompare
              ? priceVar[0].priceCompare
              : 0
            : 0,
          whosaleData: priceVar.length && priceVar[0].whosaleData ? priceVar[0].whosaleData : undefined,
          qty: priceVar.length ? priceVar[0].qty : 1,
          weight: priceVar.length ? priceVar[0].weight : this.data.weight,
          image: priceVar.length ? priceVar[0].image : "",
          isActiveMinimumPurchase: priceVar[0].isActiveMinimumPurchase,
          minimumPurchase: priceVar[0].minimumPurchase,
        });
      }
      localStorage.setItem("cartSummaryCheckout", JSON.stringify(temp), {
        expires: new Date(new Date().getTime() + 30 * 60 * 1000),
      });      
      if(this.data.multiplyVariations &&  this.data.cartOrder){
        this.cartSummary = JSON.parse(localStorage.getItem("cartSummaryCheckout"));
      }

    
      let self = this
      this.updatePrices();   

      setTimeout(() => {      
        self.$forceUpdate();
      }, 2000)
    },
    openCartSummary() {
      this.cartOrderSummary = true;
      if (this.changeVariant) {
        this.changeVariant = false;
      }
    },
    showMsg() {
      var that = this;
      setTimeout(function () {
        that.show = false;
      }, 2000); // hide the message after 2 seconds
    },
    removeFromCart(index) {
      if (this.cartSummary.length) {
        this.updateCartSummary(index)
      }
    },
    updateCartSummary(index) {
      let name = this.cartSummary[index].name;
      this.cartSummary.splice(index, 1);
      localStorage.setItem("cartSummaryCheckout", JSON.stringify(this.cartSummary), {
        expires: new Date(new Date().getTime() + 30 * 60 * 1000),
      });
      let f = this.data.variablePrices.filter(e => e.name == name)
      if (f.length) { f[0].qty = 0 }
      this.updatePrices()
      this.$forceUpdate();
    },
    increment(val, type) {
      if (type == "multipleVariant" && !this.data.cartOrder) {
        if (this.data.variablePrices[val]) {
          this.data.variablePrices[val].qty =
            parseInt(this.data.variablePrices[val].qty) + 1;
        }
      } else if (type == "singleVariant") {
        this.cartQuantity = this.cartQuantity + 1;
      }
    },
    decrement(val, type) {
      if (type == "multipleVariant" && !this.data.cartOrder) {
        if (
          this.data.variablePrices[val].qty &&
          this.data.variablePrices[val].qty > 0
        ) {
          if (this.data.variablePrices[val].qty < 1) {
            return;
          } else {
            this.data.variablePrices[val].qty =
              this.data.variablePrices[val].qty - 1;
          }
        }
      } else if (type == "singleVariant") {
        if (this.cartQuantity < 2) {
          return;
        } else {
          this.cartQuantity = this.cartQuantity - 1;
        }
      }
    },

    applyVATPercentage() {
      if(this.data && this.data.VAT && this.data.VAT.isVAT) {
        let PPNprice = 0;
        PPNprice = this.cartSummary.length > 0 && this.cartTotal > 0 ? (this.cartTotal * this.data.VAT['VATpercentage'])/100 : (this.totalPrice * this.data.VAT.VATpercentage)/100
        this.VATPrice = Math.round(PPNprice);
        this.totalPrice = this.totalPrice + this.VATPrice;
      }
    },
    resetPrices() {   
      if(this.payload.automaticDiscount){
        this.payload.automaticDiscount["amount"]=0      
      }
      this.calcPrice();
      this.calcPriceWithoutWhosale();
      this.calcTotalPrice();       
      if(this.data.showCoupon && this.shouldRecalculateAutomaticDiscount) {
        this.applyAutmaticDiscount();      
      }   
    },
    updatePrices() {    
      if(this.payload.automaticDiscount){
        this.payload.automaticDiscount["amount"]=0      
      }

      const tempDiscountsHandle = [ ...this.payload.discounts];
      if (this.payload.discounts.length){
        this.payload.discounts = [];   
      }
         
      this.calcPrice();
      this.calcPriceWithoutWhosale();
      this.calcTotalPrice();
      this.isShowVariantImage=false;
      this.data.variablePrices.map(v=>{
        if(!this.isShowVariantImage && v.image !== undefined){
            this.isShowVariantImage=true;
        }         
      }); 
      if(this.data.showCoupon && this.shouldRecalculateAutomaticDiscount) {
        this.applyAutmaticDiscount();      
      }   
      if (tempDiscountsHandle.length){
        for (const discount of tempDiscountsHandle) {
          this.applyDiscount(discount.code); 
        }
      }

      this.calcEpayFee()

      if(this.data && this.data.VAT && this.data.VAT.isVAT) {
        this.applyVATPercentage()
      }

      this.$forceUpdate();
    },

    loadVariableArray() {
      if (this.cartSummary.length != 0) {
        return this.data.variablePrices.map((variable) => {
          const cartItem = this.cartSummary.find((data) => data.name == variable.name)
          if (!cartItem) {
            return {
              ...variable,
              qty: 0
            }
          }

          return {
            ...variable,
            qty: cartItem.qty || 0,
            price: cartItem.priceOriginal || variable.price,
            priceCompare: cartItem.price || variable.priceCompare,
            whosaleData: cartItem.whosaleData || variable.whosaleData,
            weight: cartItem.weight || variable.weight,
            image: cartItem.image || variable.image,
          }
        })
      }
      return this.data.variablePrices
    },
    isCaptchaRequiredForOrder() {
      const isAbandonedCheckout = !!this.checkout_id && !!get(this.checkout_data, 'form_id');
      return this.showCaptcha && !isAbandonedCheckout;
    },

    async createData({ includePayment = true } = {}) {
      let payload = {}
      let customFields = []
      let keys = Object.keys(this.payload.variablePrices);
      let dataVal = keys.map(o => this.payload.variablePrices[o].name).join(' / ')
      this.data.requestedFields.map(one => {
        if (one.isCustom) {
          customFields.push({label: one.label,value:one.value })
        } else {
          payload[one.field] = one.value
        }
      })
      const isCaptchaRequired = this.isCaptchaRequiredForOrder();
      payload.isCaptchaRequired = isCaptchaRequired;
      payload.isCaptchaSuccess = isCaptchaRequired;
      payload.bumpArray = this.data.isBump && this.selectedbumpArray ? this.selectedbumpArray : [];
      // payload.allBumpData = this.data.isBump && this.data.bumpArray ? this.data.bumpArray : [];
      payload.isBump = this.data.isBump
      payload.checkout_id = this.checkout_id ? this.checkout_id : undefined;
      payload.handledBy = this.belongs_to
      payload.dropshipper = this.data.dropship
      if (includePayment) {
        payload.payment = this.payload.payment
        const type = this.data.paymentType.filter((p) => p.active).find(x=>x.type==this.payload.payment)
        payload.paymentMode = this.data.epaymentSettings.findIndex(x=>x.id==this.payload.payment) > -1 ? 'E-Payment' : type && type.type ?  type.type : this.payload.paymentMode
      }
      payload.ePaymentFeePaidBy = this.data.ePaymentFeePaidBy;
      payload.variations = this.data.type !== "simple" && this.data.enableProductOptions ? this.loadVariableArray() : []
      payload.product_id = this.data._id
      payload.address = this.payload.address
      payload.quantity = this.quantity
      payload.form_id = this.data.form_id
      payload.productName = this.data.name
      payload.customFields = customFields
      payload.grossRevenue = this.cartSummary.length > 0 && this.cartTotal > 0 ? Math.round(this.cartTotal +  (this.data.VAT && this.data.VAT.isVAT ? ((this.cartTotal * this.data.VAT['VATpercentage'])/100) : 0)) : this.totalPrice
      payload.checkoutPageName = this.data.pageName
      payload.productPrice = this.price
      payload.costPerItem = this.data.costPerItem
      payload.productPriceWithoutDiscount = this.data.type == 'simple' ? (this.data.price * this.quantity) : this.priceWithoutWhosale
      payload.cogsPrice = this.cogsPrice
      // Store original product pricing data for edit order (preserves historical price)
      // Only for products without variations - variant products store price in variations array
      if (!payload.variations || payload.variations.length === 0) {
        payload.originalProductPrice = this.data.price || 0
        payload.originalPriceCompare = this.data.priceCompare || 0
        payload.originalWhosaleData = this.data.whosaleData && this.data.whosaleData.length > 0
          ? JSON.parse(JSON.stringify(this.data.whosaleData))
          : []
      }
      payload.shippingType = this.data.addShipping
        ? (this.payload.payment === 'COD' ? this.data.shippingCOD.shippingType : this.data.shippingType)
        : ''
      payload.shippingPrice = this.deliveryPrice
      payload.codPrice = this.payload.payment == 'COD' ? this.codPrice : 0
      payload.uniquePrice = (this.data.codeType == 'Decrease' ? -this.payload.uniquePrice : this.payload.uniquePrice)    
      payload.hideAdditionalCost = (this.payload.payment == 'COD' ? this.data.shippingCOD.hideAdditionalCost : this.data.hideAdditionalCost) || false
      payload.additionalCost = this.data.addShipping ? parseInt(this.payload.payment === 'COD' ? this.data.shippingCOD.additionalCost : this.data.additionalCost) : 0
      function getParameterByName(name) {
        var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
      }
      payload.UTMSource = getParameterByName('utm_source')
      payload.UTMMedium = getParameterByName('utm_medium')
      payload.UTMTerm = getParameterByName('utm_term')
      payload.UTMContent = getParameterByName('utm_content')
      payload.UTMCampaign = getParameterByName('utm_campaign')
      payload.gclid = getParameterByName('gclid')
      payload.autofillSource = this.autofillSource

      payload.multipleShipFrom=this.data.multipleShipFrom
      payload.multiShipFromAddress=this.data.multiShipFromAddress

      // let ip;
      // if(localStorage.getItem('ip')) {
      //   ip = localStorage.getItem('ip');
      // }else{
      //   let lp = await axios.get('https://api.ipify.org/?format=json');
      //   localStorage.setItem('ip', lp.data.ip)
      //   ip = lp.data.ip;
      // }
      payload.metaData = {
        domain: this.domain,
        ip: this.data.ip,
        url: window.location.href
      }
      payload.ip = this.data.ip
      payload.ref = this.refid ? this.refid : undefined;    

      if(this.payload.sellerOriginId){       
        let sellerAdd = this.data.multiShipFromAddress[this.payload.sellerOriginId]
        Object.keys(this.data.multiShipFromAddress).map(id=>{
         if (this.data.multiShipFromAddress[id].address && this.data.multiShipFromAddress[id].address.PICKUP_AUTOFILL==this.payload.sellerOriginId){
          sellerAdd=this.data.multiShipFromAddress[id]
         }         
        })
        if(sellerAdd && sellerAdd.PROVINCE_NAME){
          let add =  sellerAdd.PROVINCE_NAME + ', ' + sellerAdd.CITY_NAME + ', ' + sellerAdd.DISTRICT_NAME
          payload.sellerAddress = add;
        }   
        
        sellerAdd = this.data.multiShipFromAddress[this.payload.sellerOriginId]
        if(sellerAdd && sellerAdd.PROVINCE_NAME){
          let add =  sellerAdd.PROVINCE_NAME + ', ' + sellerAdd.CITY_NAME + ', ' + sellerAdd.DISTRICT_NAME
          payload.sellerAddress = add;
        }  
        
        if(!payload.sellerAddress){
          Object.keys(this.data.multiShipFromAddress).map(id=>{
            if (this.data.multiShipFromAddress[id] && this.data.multiShipFromAddress[id].PICKUP_AUTOFILL==this.payload.sellerOriginId){
              sellerAdd=this.data.multiShipFromAddress[id]
            }         
          })
          if(sellerAdd && sellerAdd.PROVINCE_NAME){
            let add =  sellerAdd.PROVINCE_NAME + ', ' + sellerAdd.CITY_NAME + ', ' + sellerAdd.DISTRICT_NAME
            payload.sellerAddress = add;
          }   
        }   
        
        payload.sellerAddressPickupAutofill = this.payload.sellerOriginId;       
      }  

      if (this.payload.deliveryPrice) {
        payload.shippingInfo = {
          deliveryType: this.payload.deliveryType,
          deliveryPrice: this.payload.deliveryPrice,
          deliveryCourier: this.payload.deliveryCourier,
          shippingDiscountValue: this.payload.shippingDiscountValue,
        }
      }

      if (this.data && this.data.isBump && this.selectedbumpArray && this.selectedbumpArray.length >= 0) {
        // price = price + parseFloat(this.data.bumpPrice)
        let totalBumpPrice = 0
        this.selectedbumpArray.map((bumpData) => {
          // const bumpData = this.data.bumpArray.find((data) => data.bump_id == bump_id)
          if (bumpData) {
            totalBumpPrice = totalBumpPrice + parseFloat(bumpData.bumpPrice)
          }
        })
        payload.bumpPrice = totalBumpPrice
      }

      // if (this.payload.bump) {
      //   payload.bumpPrice = this.data.bumpPrice 
      // }
      if (this.data.type !== "simple" && !this.data.multiplyVariations && !this.data.addQuantity && (this.data.requestedFields.find(d => d.field == 'quantity') && this.data.requestedFields.find(d => d.field == 'quantity').active)) {
        payload.variations.map((attr) => {
          if (attr.name == dataVal) {
            attr.qty = this.quantity
          }
        })
      }

      if(this.data.VAT && this.data.VAT.isVAT) {
        payload.VAT = { 
          isVAT : this.data.VAT['isVAT'],
          value : this.data.VAT['VATpercentage'], 
          amount : this.VATPrice
        }
      }

      if (this.inputEmailConfirm && this.inputEmailConfirm.length) {
        payload.email = this.inputEmailConfirm;
      }
      
      payload.discounts=this.payload.discounts;    

      payload.automaticDiscount=this.payload.automaticDiscount;
      payload.ePayFee = this.payload.ePayFee;
      payload.trackingEventKey = this.payload.trackingEventKey;
      payload.originalShippingCost = payload.paymentMode === "COD" ? this.data.shippingCOD.originalShippingCost : this.data.originalShippingCost;

      return payload;
    },
    async save() {
      try {
        if (!this.data.enableProductOptions && this.data.trackQuantity && this.data.available < 1 && !this.data.continueSelling) {
          return
        }
        // this.loadingPrice = true;
        let payload = await this.createData();
        if (this.data.preOrder) {
          payload.preOrder = this.data.preOrder
        }

        if (this.lastAssignee) {
          payload.handledBy = this.lastAssignee
        }

        if (this.isArchivedOrder) {
          payload.isArchived = true
        }

        if (this.affiliate &&this.affiliate.shareFrom) {
          payload.shareFrom = this.affiliate.shareFrom;
        }

        let {fbp, fbc} = this.getfbpc();

        payload.fbp = fbp
        payload.fbc = fbc
        const hmac = createHmac('sha256', secret);
        hmac.update(JSON.stringify(payload));
        const signature = hmac.digest('hex');
      
        const orderApiUrl = !this.embed && typeof window !== 'undefined'
          ? `${window.location.origin}/api/order`
          : config.api + 'order';
        // withCredentials lets the embed (cross-site) store and resend the device cookie
        let res = await axios.post(orderApiUrl, {data:payload, signature}, { withCredentials: true })
        if (res.data.success) {
          this.doRedirect = false;
          
          // await this.createScripts(res.data.data);
          if (res.data.isDuplicateOrder) {
            localStorage.removeItem("cartSummaryCheckout");
            localStorage.removeItem("tuktukSummaryCheckout");
            this.orderCreated = true;
            // if (!window.location.host.includes('form-id') && !window.location.host.includes('form.id') && !window.location.host.includes('localhost')) {
            //   const redirectUrl = config.baseUrl.replace('dist', '')
            //   let url = redirectUrl + 'success/' + this.data.url + '?order=' + res.data.data._id;
            //   window.location.href = url
            //   return
            // }
            this.doRedirectAfterOrder(res);

            return
          }
          localStorage.removeItem("cartSummaryCheckout");
          localStorage.removeItem("tuktukSummaryCheckout");
          let timeout = 0;
          const hasFB = !this.isFbPixelDisabled && this.data.pixelsFB && this.data.pixelsFB.length > 0;
          const hasGTM = !this.isGtmDisabled && this.data.GTM && this.data.GTM.length > 0;
          if(this.data.pixelsGoogleAds && this.data.pixelsGoogleAds.length > 0 || hasFB || hasGTM || this.data.pixelsTiktok){
            timeout= 700
          }
          setTimeout(() => {
            if (res.data.transaction) {
              // let url = this.baseUrl.split('://')[0] + '://' + this.baseUrl.split('://')[1] + 'ePayment?uid=' + res.data.transaction.token + '&domain=' + this.domain;

              const base = new URL('ePayment', this.baseUrl)
              base.search = new URLSearchParams({
                uid: res.data.transaction.token,
                domain: this.domain,
                product_url: this.data.url,
                order_data: res.data.data._id
              }).toString()
              const url = base.toString()

              window.location.href = url
            } else {
              this.orderCreated = true;

              // if (!window.location.host.includes('form-id') && !window.location.host.includes('form.id') && !window.location.host.includes('localhost')) {
                //   const redirectUrl = config.baseUrl.replace('dist', '')
              //   let url = redirectUrl + 'success/' + this.data.url + '?order=' + res.data.data._id;
              //   window.location.href = url
              //   return
              // }
              this.doRedirectAfterOrder(res);
            }
          }, timeout)
        } else {
          // we do not need to clear bump product.
          // if(res.data.message.includes("Bump product is Out of stock")){
          //   this.data.isBump = false
          //   this.selectedbumpArray =[]
          // }
          this.$vs.notification({
            icon: `<i class='icon-info'></i>`,
            color: "danger",
            position: "top-right",
            text: res.data.message,
            duration: 2000,
          });
          this.isBuyButtonLoading = false;
          return;
        }
       
      } catch (error) {
        if (error.response && error.response.data && error.response.data.message === 'invalid phone number') {
          error.message = error.response.data.message
          this.isInvalidCustomerPhone = error.message

          // tuktuk theme
          this.errors['phone'] = 'Nomor whatsapp tidak terdaftar'

          // classic theme
          setTimeout(() => {
            const inputErrors = document.getElementsByClassName('scroll-to-error-message');
            inputErrors[0] && inputErrors[0].scrollIntoView({ behavior: 'smooth' })
          }, 200)
        }
        this.$vs.notification({
          icon: `<i class='icon-info'></i>`,
          color: "danger",
          position: "top-right",
          text: error && error.message ? error.message : "Error creating order",
          duration: 2000,
        });

        this.isBuyButtonLoading = false;
        return;
      } finally {
        this.inputEmailConfirm = '';
      }
    },
    doRedirectAfterOrder(res){
      let {fbp, fbc} = this.getfbpc();
      let url = window.location.protocol + "//" + this.domain + '/success/' + this.data.url + '?order=' + res.data.data._id +`&fbp=${fbp}&fbc=${fbc}`;
      window.location.href = url
    },
    async estimate(force = false, refetch = false) {
      const shippingType = this.payload.payment === 'COD' ? this.data.shippingCOD.shippingType : this.data.shippingType;
      const orignalPrice = this.payload.payment === 'COD' ? this.data.shippingCOD.originalShippingCost : this.data.originalShippingCost;

      const reqUrl = `${this.baseUrl}api/tracking/allEstimatePublic`;

      let val = this.payload.address
      // The estimate API only needs the destination id, so the id is also the cache key:
      // one region code (e.g. JNE) can cover several villages that other couriers price
      // differently, and addresses saved by older checkouts have no DESTINATION_CODE at all.
      const hasCompleteDestination = val && val.customerAUTOFILL
      const destinationKey = hasCompleteDestination ? val.customerAUTOFILL : ''
      const shouldEstimate = (this.data.addShipping && shippingType == 'automated') || refetch
      if (!hasCompleteDestination) {
        if (shouldEstimate) {
          this.cancelShippingEstimate()
          this.DESTINATION_CODE = ''
          this.allEstimatePublic = {}
          this.delivery = {}
          this.courierOptionDataFinal = []
          this.courierOptionDataCargo = []
          this.deliveryCourierPrice = ''
          this.payload.deliveryType = ''
          this.payload.deliveryPrice = 0
          this.payload.deliveryCourier = ''
          this.payload.sellerOriginId = null
          this.loadingPrice = false
        }
        return
      }

      if (shouldEstimate) {
        if (this.DESTINATION_CODE !== destinationKey || force || refetch) {
          this.DESTINATION_CODE = destinationKey
          let weight = this.weight
          weight = weight / 1000
          if (weight < 1) {
            weight = 1
          }
          // weight = Math.ceil(weight);
          // let origin = this.data.shipFrom.split('-').length > 0 ? this.data.shipFrom.split('-')[0] : this.data.shipFrom

          // A newer estimate (another address, payment or quantity) replaces the one in flight,
          // so an older answer never overwrites the couriers of the current address.
          this.cancelShippingEstimate()
          const requestId = this.shippingEstimateRequestId
          const isStale = () => requestId !== this.shippingEstimateRequestId
          const cancelSource = axios.CancelToken.source()
          this.shippingEstimateCancelSource = cancelSource
          const fetchEstimate = params => requestShippingEstimate(
            () => axios.get(reqUrl, { params, timeout: SHIPPING_ESTIMATE_TIMEOUT, cancelToken: cancelSource.token }),
            { isStale }
          )

          this.loadingPrice = true
          let destination_to = val.customerAUTOFILL
          this.payload.deliveryType = '';
          this.payload.deliveryPrice = 0;
          this.payload.deliveryCourier = '';
          this.delivery = {};

          try {
            // Shipping estimate API
            if(this.data.multipleShipFrom.length > 0 && this.data.multiShipFromAddress) {
              // let courierVal = [];
              // this.shippingCourierTypes.map((key)=> {           
              //   const isActive = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
              //     ? this.data.shippingCOD[key]
              //     : this.data[key];
              //   if (isActive){
              //     courierVal.push(key);
              //   } else {
              //     return ;
              //   }
              // })
              let deliveryCopy={};  
              this.shippingCourierTypes.forEach(e=>{
                deliveryCopy[e] = [];
              });

              await Promise.all(this.data.multipleShipFrom.map(async(item)=>{
                let splitshipfrom = item.split('-');
                let origin_id = splitshipfrom.length > 2 ? splitshipfrom[splitshipfrom.length-1] : splitshipfrom[0];
                let address=this.data.multiShipFromAddress[origin_id]
                if(this.data.multiShipFromAddress && this.data.multiShipFromAddress[origin_id] && this.data.multiShipFromAddress[origin_id].address){
                  address=this.data.multiShipFromAddress[origin_id]

                  origin_id=this.data.multiShipFromAddress[origin_id].address.PICKUP_AUTOFILL
                }
                // One origin failing still leaves the couriers of the other origins.
                let res
                try {
                  res = await fetchEstimate({ username: this.user.username, origin_id: origin_id, destination_id: destination_to, weight: weight, from: orignalPrice ? "origin" : undefined })
                } catch (error) {
                  return
                }
                if (isStale()) return
          
                if (res.data.success && res.data.data) {
                  this.allEstimatePublic = res.data.data
                  this.shippingCourierTypes.map((courier)=>{          
                  
                    const courierFormData= (courier.toLowerCase() == 'sicepat') ? 'SiCepat' : (courier== 'jNt') ? 'JT' : (courier== 'jne') ? 'JNE' : (courier== 'sap') ? 'SAP'  : (courier== 'ninja') ? 'Ninja' :  courier;   
                      if (res.data.success && res.data.data && res.data.data[courierFormData]) {
                        res.data.data[courierFormData]['address'] =address
                        res.data.data[courierFormData]['origin_id']= origin_id
                        if(isDisplayableShippingEstimate(res.data.data[courierFormData], this.data.isShippingCoverageCheckEnabled)) {
                          deliveryCopy[courier].push(res.data.data[courierFormData]);
                        }
                      }
                  })

                  // for cargo couriers
                  this.shippingCourierTypesCargo.forEach((courierCargoKey) => {
                    // const isActive = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
                    //   ? this.data.shippingCOD[courierCargoKey]
                    //   : this.data[courierCargoKey];

                    if (res.data.data[courierCargoKey] && res.data.data[courierCargoKey].price > 0) {
                      if (!this.delivery[courierCargoKey]) {
                        this.delivery[courierCargoKey] = [];
                      }

                      res.data.data[courierCargoKey]['address']  = address
                      res.data.data[courierCargoKey]['origin_id'] = origin_id
                      this.delivery[courierCargoKey].push(res.data.data[courierCargoKey]);
                      this.delivery[courierCargoKey].sort((a, b) => a.price - b.price); // sort by price ascending
                    }
                  })
                }
              }))
              if (isStale()) return
              // Sort the prices in increasing order for cost-effective
              Object.values(this.shippingCourierItems).map(c=>{          
                if (Array.isArray(deliveryCopy[c.val]) && deliveryCopy[c.val].length > 0) {
                  const pricedEstimates = deliveryCopy[c.val].filter(estimate => Number(estimate.price) > 0)
                  const estimates = pricedEstimates.length > 0 ? pricedEstimates : deliveryCopy[c.val]
                  estimates.sort((a, b) => Number(a.price || 0) - Number(b.price || 0));
                  this.delivery[c.val] = [estimates[0]]
                }   
              })
            } else if(this.data.shipFrom) {
              let splitshipfrom = this.data.shipFrom.split('-');
              let origin_id = splitshipfrom.length > 2 ? splitshipfrom[splitshipfrom.length-1] : splitshipfrom[0];

              let delivery={};
              // let shippingCourierTypes=["JNE",'JT','Ninja','SAP','SiCepat','SiCepatCargo','iDexpress','iDlite'];
              this.shippingCourierTypes.forEach(e=>{ // TODO OR should be removed after integrate with API
                delivery[e] = [];
              });
              // let courierVal = [];
              // this.shippingCourierTypes.map((key)=> {           
              //   const isActive = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
              //     ? this.data.shippingCOD[key]
              //     : this.data[key];

              //   if (isActive){
              //     courierVal.push(key);
              //   }else{
              //     return ;
              //   }
              // })
              let res
              try {
                res = await fetchEstimate({ username: this.user.username, origin_id: origin_id, destination_id: destination_to, weight: weight, from: orignalPrice ? "origin" : undefined })
              } catch (error) {
                res = { data: {} }
              }
              if (isStale()) return
          
              if (res.data.success && res.data.data) {          
                this.shippingCourierTypes.map((courier)=>{          
    
                  // const courierParam= (courier.toLowerCase() == 'sicepat') ? 'siCepat' : (courier== 'sap') ? 'Sap':  courier;   
                  const courierFormData= (courier.toLowerCase() == 'sicepat') ? 'SiCepat' : (courier== 'jNt') ? 'JT' : (courier== 'jne') ? 'JNE' : (courier== 'sap') ? 'SAP'  : (courier== 'ninja') ? 'Ninja' :  courier;   
                        
                    if (res.data.success && res.data.data && res.data.data[courierFormData]) {
                      delivery[courier] = [res.data.data[courierFormData]];
                      delivery[courier].push({});
                      delivery[courier].pop();
                    }
                })

                // for cargo couriers
                this.shippingCourierTypesCargo.forEach((courierCargoKey) => {
                  // const isActive = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
                  //   ? this.data.shippingCOD[courierCargoKey]
                  //   : this.data[courierCargoKey];

                  if (res.data.data[courierCargoKey] && res.data.data[courierCargoKey].price > 0) {
                    if (!this.delivery[courierCargoKey]) {
                      this.delivery[courierCargoKey] = [];
                    }

                    this.delivery[courierCargoKey].push(res.data.data[courierCargoKey]);
                    this.delivery[courierCargoKey].sort((a, b) => a.price - b.price); // sort by price ascending
                  }
                })
              }
          
              this.delivery={...delivery}; 
          
            }

            // common for old and new product
            this.courierOptionDataFinal=[];
            Object.values(this.shippingCourierItems).map(c=>{   
              if(this.delivery[c.val] && this.delivery[c.val].length>0){
                this.delivery[c.val].map(p=>{   
                  if(this.shippingCourierTypes.includes(c.val) && isDisplayableShippingEstimate(p, this.data.isShippingCoverageCheckEnabled)) {
                    const deliveryPrice = Number(p.price) > 0 ? p.price : 0
                    this.courierOptionDataFinal=[...this.courierOptionDataFinal,{
                      imageSrc: c.imageSrc,
                      value:c.val+"=="+deliveryPrice,
                      label:c.label+" - "+(p.type?p.type:'REG')+" - Rp"+ Vue.filter('g_number_format')(deliveryPrice),
                      label2:c.label2+" - "+(p.type?p.type:'REG')+" - Rp"+Vue.filter('g_number_format')(deliveryPrice),
                      key:c.val,
                      shipFromAddress:p.address,
                      origin_id:p.origin_id,
                      estimate_delivery: p.estimate_delivery,
                      unsupported: p.unsupported,
                      unsupported_cod: p.unsupported_cod,
                    }];  
                  }
                });

                const courierOptionFinalTemp = [...this.courierOptionDataFinal];
                if (
                  courierOptionFinalTemp &&
                  courierOptionFinalTemp.length > 1 &&
                  this.shippingHideView
                ) {
                  const cheapestOption = courierOptionFinalTemp
                    .filter(courier => {
                      return this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
                        ? this.data.shippingCOD[courier.key]
                        : this.data[courier.key]
                    })
                    .reduce((min, current) => {
                      const getPrice = (value) => value ? parseInt(value.split('==')[1], 10) : 0;
                      return getPrice(current.value) < getPrice(min.value) ? current : min;
                    }, {});
                
                  if (cheapestOption && cheapestOption.key) {
                    this.courierOptionDataFinal = [cheapestOption];
                  }
                }

                // Sort the courierOptionDataFinal array based on the this.data.courierType
                const orderArray = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
                  ? (this.data.shippingCOD.courierType || [])
                  : (this.data.courierType || [])
                const courierKeyMap = {};
                orderArray.forEach((key, index) => {
                  courierKeyMap[key.toLowerCase()] = index;
                });
    
                this.courierOptionDataFinal.sort((a, b) => {
                  const courierA = a.value.split('==')[0].toLowerCase();
                  const courierB = b.value.split('==')[0].toLowerCase();
                  return courierKeyMap[courierA] - courierKeyMap[courierB];
                });
              }                
            }) 

            // set cargo options
            this.courierOptionDataCargo = Object.keys(this.delivery)
              .filter(cargoKey => this.shippingCourierTypesCargo.includes(cargoKey))
              .map(cargoKey => {   
                const cheapestCourierCargo = this.delivery[cargoKey][0] || {};
                const courierMetadata = this.shippingCourierItemsCargo[cargoKey];

                if (courierMetadata && cheapestCourierCargo.price) {
                  return {
                    imageSrc:  courierMetadata.imageSrc,
                    value: courierMetadata.val+"=="+cheapestCourierCargo.price,
                    label: courierMetadata.label+" - "+"Cargo"+" - Rp"+ Vue.filter('g_number_format')(cheapestCourierCargo.price),
                    label2: courierMetadata.label2,
                    key: courierMetadata.val,
                    shipFromAddress: cheapestCourierCargo.address,
                    origin_id: cheapestCourierCargo.origin_id,
                    estimate_delivery: cheapestCourierCargo.estimate_delivery_cargo,
                    unsupported: cheapestCourierCargo.unsupported,
                    unsupported_cod: cheapestCourierCargo.unsupported_cod,
                    minimumWeightCargo: cheapestCourierCargo.minimumWeightCargo || 10,
                  };
                }

                return null
              })
              .filter(Boolean)
              .sort((a, b) => {
                const cargoOrders = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
                  ? (this.data.shippingCOD.cargoCourierType || [])
                  : (this.data.cargoCourierType || [])
                return cargoOrders.indexOf(a.key) - cargoOrders.indexOf(b.key)
              });

            // Set default selected courier is the lowest price
            const selectableRegularCouriers = this.courierListRegular.filter(courier => (
              !this.data.isShippingCoverageCheckEnabled || (
                courier.unsupported !== true &&
                !(this.payload.payment === 'COD' && courier.unsupported_cod === true)
              )
            ))
            const cheapestCourier = couriers => couriers.reduce((next, current) => {
              const currentPrice = parseInt(current.value.split('==')[1] || '0')
              const nextPrice = parseInt(next.value.split('==')[1] || '0')
              return currentPrice < nextPrice ? current : next;
            }, couriers[0])
            let defaultSelectedCourier = cheapestCourier(selectableRegularCouriers)

            const hasCargoShipping = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
              ? this.data.shippingCOD.hasCargoShipping
              : this.data.hasCargoShipping
            const hasRegularShipping = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
              ? this.data.shippingCOD.hasRegularShipping
              : this.data.hasRegularShipping

            if (hasCargoShipping && (!hasRegularShipping || (hasRegularShipping && !defaultSelectedCourier))) defaultSelectedCourier = cheapestCourier(this.courierListCargo)

            // Every courier is out of reach: keep the cheapest one selected (shown greyed out) so
            // Buy Now answers with the seller's "Pesanan tidak diproses" / "Pesanan diproses" choice.
            const isUnreachableSelection = !defaultSelectedCourier && this.courierListRegular.length > 0
            if (isUnreachableSelection) defaultSelectedCourier = cheapestCourier(this.courierListRegular)

            if (defaultSelectedCourier) {
              this.payload.sellerOriginId = defaultSelectedCourier.origin_id
              let price = (defaultSelectedCourier.value || "").split("==");
              const savedCourier = this.checkout_data && this.checkout_data.shippingInfo
                ? this.checkout_data.shippingInfo.deliveryCourier
                : ''
              const hasUnavailableSavedCourier = isInactiveShippingCourier(savedCourier) || (
                savedCourier && !(isUnreachableSelection ? this.courierListRegular : selectableRegularCouriers).some(courier => courier.key === savedCourier)
              )
              const deliveryCourier = hasUnavailableSavedCourier
                ? ''
                : !this.payload.deliveryCourier && this.checkout_data.shippingInfo
                 ? (this.checkout_data.shippingInfo.deliveryCourier || price[0] || "")
                : price[0] || "";
              const deliveryPrice = hasUnavailableSavedCourier
                ? 0
                : !this.payload.deliveryPrice && this.checkout_data.shippingInfo
                 ? (this.checkout_data.shippingInfo.deliveryPrice || price[1] || "")
                : price[1] || "";

              let labelParts = (defaultSelectedCourier.label || "").split("-");
              const deliveryType = hasUnavailableSavedCourier
                ? ''
                : !this.payload.deliveryType && this.checkout_data.shippingInfo
                 ? (this.checkout_data.shippingInfo.deliveryType || (labelParts[1] && labelParts[1].trim()) || "REG")
                : (labelParts[1] && labelParts[1].trim()) || "REG";

              this.$set(this.payload, 'deliveryCourier', deliveryCourier);
              this.$set(this.payload, 'deliveryPrice', deliveryPrice);
              this.$set(this.payload, 'deliveryType', deliveryType);

              this.deliveryCourierPrice = this.payload.deliveryCourier + "==" + this.payload.deliveryPrice;
            }
          } catch (error) {
            // Keep no courier of the previous address on screen once this estimate broke.
            if (!isStale()) {
              this.courierOptionDataFinal = []
              this.courierOptionDataCargo = []
              this.deliveryCourierPrice = ''
            }
          } finally {
            // Always release the buy button, unless a newer estimate now owns it.
            if (!isStale()) {
              this.shippingEstimateCancelSource = null
              this.loadingPrice = false
            }
          }
        }
      }
    },
    cancelShippingEstimate() {
      this.shippingEstimateRequestId++
      if (this.shippingEstimateCancelSource) {
        this.shippingEstimateCancelSource.cancel('Shipping estimate replaced by a newer request.')
        this.shippingEstimateCancelSource = null
      }
    },
    isSpxOptionAvailable(option) {
      if (!option || String(option.key).toLowerCase() !== 'spx') return true

      const price = Number(String(option.value || '').split('==')[1])
      if (!Number.isFinite(price) || price <= 0) return false

      return !option.unsupported && !(this.payload.payment === 'COD' && option.unsupported_cod)
    },
    reselectUnavailableSpx() {
      if (String(this.payload.deliveryCourier || '').toLowerCase() !== 'spx') return
      if (this.courierListRegular.some(option => option.key === 'spx')) return

      const options = this.courierListRegular.length ? this.courierListRegular : this.courierListCargo
      const cheapest = options.reduce((min, current) => {
        if (!min) return current
        return parseInt(current.value.split('==')[1] || '0') < parseInt(min.value.split('==')[1] || '0') ? current : min
      }, null)

      if (!cheapest) {
        this.$set(this.payload, 'deliveryCourier', '')
        this.$set(this.payload, 'deliveryPrice', 0)
        this.$set(this.payload, 'deliveryType', '')
        this.deliveryCourierPrice = ''
        return
      }

      const [deliveryCourier, deliveryPrice] = cheapest.value.split('==')
      const labelParts = (cheapest.label || '').split('-')
      this.payload.sellerOriginId = cheapest.origin_id
      this.$set(this.payload, 'deliveryCourier', deliveryCourier)
      this.$set(this.payload, 'deliveryPrice', deliveryPrice)
      this.$set(this.payload, 'deliveryType', (labelParts[1] && labelParts[1].trim()) || 'REG')
      this.deliveryCourierPrice = `${deliveryCourier}==${deliveryPrice}`
    },
    initiateScript() {
      if (this.data.GTA && this.data.GTALabel) {
        //eslint-disable-next-line
        this.scripts.push({ script: "<script defer src='https://www.googletagmanager.com/gtag/js?id=AW-" + this.data.GTA + "'><\/script>", name: "GTA", type: "GTA" });
        //eslint-disable-next-line
        this.scripts.push({ script: "<script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date()); gtag('config', 'AW-" + this.data.GTA + "');<\/script>", name: "GTA", type: "GTA" });
      }
    },
    checkSession(param){
      if(sessionStorage.getItem(param)){
        return true
      }
      if (!sessionStorage.getItem(param)) {
        sessionStorage.setItem(param, true);
      }
      return false;
    },
    async createScripts() {
      let { fbp, fbc } = this.getfbpc();
      const tracking = {
        globalConversionSetting: this.data.globalConversionSetting,
        GTA: this.data.GTA,
        GTALabel: this.data.GTALabel,
        FB: this.isFbPixelDisabled ? [] : this.data.pixelsFB,
        GTM: this.isGtmDisabled ? [] : this.data.GTM,
        tiktok: this.data.pixelsTiktok,
        GA: this.data.pixelsGoogleAds,
        snack: this.data.pixelsSnack,
      }

      const data = {
        id: this.data.form_id || this.data._id || '',
        fbp,
        fbc,
        page_name: this.data.name,
        page_category: this.data.category,
        content_name: this.data.name,
        content_ids: getContentIds(this.data.enableProductOptions, this.data.variablePrices, this.data.SKU, false),
        value: this.data.priceCompare > 0 ? this.data.priceCompare : this.data.price,
        quantity: this.totalQuantity || 1,
        description: this.data.name,
      };
      const { event_key } = await createTrackingScripts(tracking, data, this.scripts, {
        excludedEventNames: ['Purchase'],
      });
      this.payload.trackingEventKey = event_key;
    },
    async createAbandon() {
    if (this.cancelTokenSource) {
      this.cancelTokenSource.cancel('Request canceled due to new request.');
    }

    this.cancelTokenSource = axios.CancelToken.source();

    if (!this.orderCreated) {
      let payload = await this.createData({
        includePayment: this.payload._paymentSelectedByBuyer === true
      });

      if (payload && payload.phone) {
        payload.productType = this.data.digitalProduct !== undefined ? 'digital' : 'physical';
        payload.metaData = {
          domain: this.domain,
          ip: this.data.ip,
          url: window.location.href
        };
        payload.productUrl = this.data.url;

        const url = this.checkout_id
          ? config.api + 'order/checkout/update'
          : config.api + 'order/checkout';

        const apiData = this.checkout_id
          ? { payload, checkout_id: this.checkout_id }
          : payload;

        if (this.affiliate && this.affiliate.shareFrom) {
          apiData["shareFrom"] = this.affiliate.shareFrom
        }

        try {
          const e = await axios.post(url, apiData, {
            cancelToken: this.cancelTokenSource.token
          });

          if (e.data && e.data.data && e.data.data._id && !this.checkout_id) {
            this.checkout_id = e.data.data.checkout_id;
            this.id = e.data.data._id;
          }

        } catch (err) {
          if (axios.isCancel(err)) {
            console.log('Request canceled due to new request.');
          } else {
            console.error(err);
          }
        }
      }
    }
  },
    calcPrice() {
      let price = 0;
      this.totalQuantity=0;
      let keys = Object.keys(this.payload.variablePrices);
      let dataVal = this.payload.variablePrices
        ? keys.map(o => this.payload.variablePrices[o].name).join(' / ')
        : undefined;

       if(this.cartSummary.length > 0) {
        const wholesaleQty = this.data.multiplyVariations && this.data.cartOrder
          ? this.cartSummary.reduce((total, item) => total + parseInt(item.qty || 0), 0)
          : 0;
        this.cartSummary.map(async (e) => {
          if (!e) return;
          let subPrice = (e.price ? e.price : e.priceOriginal) * e.qty;
          if (e.whosaleData) {
            e.whosaleData.map((one) => {
              const qtyForWholesale = wholesaleQty || parseInt(e.qty);
              if (one.count && parseInt(one.count) <= qtyForWholesale) {
                subPrice = one.price * parseInt(e.qty);
              }
              // return subPrice
            });
          }
          price = price + subPrice;
       })
      }else if (
        this.data.type !== "simple" &&
        this.data.variablePrices &&
        this.data.variablePrices.length &&
        keys.length
      ) {
        this.data.variablePrices.map((attr) => {


          let qty = parseInt(this.data.multiplyVariations ?  attr.qty : this.data.addQuantity ? this.cartQuantity : this.quantity);
          if(this.data.multiplyVariations && this.data.cartOrder &&  this.cartSummary.length==0){
            qty = parseInt(this.data.multiplyVariations && this.cartSummary.length>0 ? attr.qty :  this.data.addQuantity ? this.cartQuantity : this.quantity);
          }
          // let qty = parseInt(
          //   !this.data.multiplyVariations ? this.cartQuantity : attr.qty
          // );
          let subPrice = attr.priceCompare ? attr.priceCompare : attr.price;
          if (attr.name == dataVal) {
            if (!this.data.multiplyVariations && dataVal || (this.data.multiplyVariations && dataVal && this.data.cartOrder) || (this.data.multiplyVariations && !this.data.cartOrder && !this.data.addQuantity) || (this.data.multiplyVariations && !this.data.cartOrder && this.data.addQuantity)) {
              let temp = this.data.variablePrices.filter(
                (a) => a.name == dataVal
              );
              if (temp.length) {
                subPrice =
                  temp[0].priceCompare && temp[0].priceCompare != 0
                    ? temp[0].priceCompare
                    : temp[0].price;
                price = 0;
              }
              attr.whosaleData.map((one) => {
                if (one.count && parseInt(one.count) <= parseInt(qty)) {
                  subPrice = one.price;
                }
              });
              price = price + subPrice * qty;
              this.totalQuantity=this.totalQuantity+qty;
            }
          } else {
            if ((this.data.multiplyVariations && !this.data.cartOrder && !this.data.addQuantity) || (this.data.multiplyVariations && !this.data.cartOrder && this.data.addQuantity)) {
              attr.whosaleData.map((one) => {
                if (one.count && parseInt(one.count) <= parseInt(qty)) {
                  subPrice = one.price;
                }
              });
              price = price + (subPrice * qty);
              this.totalQuantity=this.totalQuantity+qty;
            }
          }
        });
      } else {
        let getQty = this.cartQuantity > 1 ? this.cartQuantity : this.quantity;
        price = this.data.priceCompare
          ? this.data.priceCompare
          : this.data.price;
        this.data.whosaleData.map((one) => {
          if (one.count && one.count <= getQty) {
            price = one.priceCompare && one.priceCompare != 0 ? one.priceCompare : one.price;
          }
        });
        price = price * getQty;
        this.totalQuantity=this.totalQuantity+getQty;
      }
      this.price = price
    },
    calcPriceWithoutWhosale() {
      let price = 0;
      let keys = Object.keys(this.payload.variablePrices);
      let dataVal = this.payload.variablePrices
        ? keys.map(o => this.payload.variablePrices[o].name).join(' / ')
        : undefined;
      if (
        this.data.type !== "simple" &&
        this.data.variablePrices &&
        this.data.variablePrices.length &&
        keys.length
      ) {
        this.data.variablePrices.map((attr) => {
          if (attr.qty) {
            // let qty = parseInt(
            //   !this.data.multiplyVariations ? this.quantity : attr.qty
            // );
            let qty = parseInt(this.data.multiplyVariations ? attr.qty : this.data.addQuantity ? this.cartQuantity : this.quantity);
            if(this.data.multiplyVariations && this.data.cartOrder && this.data.addQuantity &&  this.cartSummary.length==0){
            qty = parseInt(this.data.multiplyVariations && this.cartSummary.length>0 ? attr.qty : this.data.addQuantity ? this.cartQuantity : this.quantity);
          }
            let subPrice = attr.price;
            price = price + subPrice * qty;
          } 
        });       
        if ((!this.data.multiplyVariations ||  (this.data.multiplyVariations && this.data.cartOrder && !this.data.addQuantity)) && dataVal) {
          let temp = this.data.variablePrices.filter((a) => a.name == dataVal);
          if (temp.length) {

            let qty = this.data.addQuantity && this.cartQuantity >= 1 ? this.cartQuantity : this.quantity;
            price = temp[0].price * qty;
          }
        }
      } else {
        price = this.data.price;
        price = price * this.quantity;
      }
      this.priceWithoutWhosale = price
    },
    calcTotalPrice() {
      const isPaymentCOD = this.payload.payment === 'COD';
      const shippingType = isPaymentCOD ? this.data.shippingCOD.shippingType : this.data.shippingType;
      const additionalCost = isPaymentCOD ? this.data.shippingCOD.additionalCost : this.data.additionalCost;
      
      let price = parseFloat(this.price) + parseFloat(this.deliveryPrice ? this.deliveryPrice : 0)
      price = price + parseFloat(this.codPrice)

      if (this.shippingDiscountValue && this.data.addShipping && shippingType == "automated" && this.shippingDiscountValue > 0) {
        price = price - parseFloat(parseFloat(this.shippingDiscountValue));
      }

      if (additionalCost && this.data.addShipping) {
        price = price + parseFloat(additionalCost)
      }
      if (this.data && this.data.isBump && this.selectedbumpArray && this.selectedbumpArray.length >= 0) {
        // price = price + parseFloat(this.data.bumpPrice)
        this.selectedbumpArray.map((bumpData) => {
          // const bumpData = this.data.bumpArray.find((data) => data.bump_id == bump_id)
          if (bumpData) {
            price = price + parseFloat(bumpData.bumpPrice ? bumpData.bumpPrice : 0)
          }
        })
      }
      if (this.data.isUniqueCode && (!this.payload.uniquePrice || this.payload.uniquePrice<2)) {
        // Generate a random number within the product's configured code range,
        // capped by the price so it can't exceed the order total.
        let min = Number(this.data.codeMin || 1);
        let max = Number(this.data.codeMax || 999);
        if (!Number.isFinite(min) || min < 1) min = 1;
        if (!Number.isFinite(max) || max < min) max = min;
        if (price > 0 && max > price) max = price;
        if (max < min) max = min;
        let r = Math.floor(Math.random() * (max - min + 1)) + min;
        this.payload.uniquePrice = r
        this.payload.uniqueType = this.data.codeType
      }
      if (this.payload.uniquePrice && this.payload.payment == 'bankTransfer') {
        price = price + (this.data.codeType == 'Decrease' ? -this.payload.uniquePrice : this.payload.uniquePrice)
      }
      if (typeof price == 'string') {
        price = parseFloat(price)
      }

      this.totalPrice = parseInt(price.toFixed());
    }, 
    calcEpayFee() {
      this.payload.ePayFee = calculateEpayFee(this.payload.payment, this.data.ePaymentFeePaidBy || 'buyer', this.totalPrice);
      this.totalPrice = parseInt(this.totalPrice.toFixed()) + this.payload.ePayFee;
    },
    goNext() {
      const url=window.location.href.split("/");     
      if(window.location.href.indexOf("/checkout") == -1){
        const newURl=url[0]+"//"+url[2]+"/"+url[3];       
        if (window.history && window.history.pushState) {       
          window.history.pushState('forward', null, newURl);  
          this.$router.push({
              path: "/" +url[3],
          });
        }
      }
    }, 
    calculateShippingDiscount(){
      const isPaymentCOD = this.payload.payment === 'COD';
      const shippingDiscount = isPaymentCOD ? this.data.shippingCOD.shippingDiscount : this.data.shippingDiscount;    
      this.shippingDiscountValue=0; 
      if(shippingDiscount && shippingDiscount.status){
        if(shippingDiscount.type=='percentage'){
          const percentage = (this.payload.deliveryPrice*shippingDiscount.value)/100;
          this.shippingDiscountValue=  percentage > this.payload.deliveryPrice ? this.payload.deliveryPrice : percentage;

        }else{
          this.shippingDiscountValue=  shippingDiscount.value > this.payload.deliveryPrice ? this.payload.deliveryPrice : shippingDiscount.value;
        }     
        this.payload.shippingDiscountValue= this.shippingDiscountValue;   
      } 
    },  
    updateAttributeValue(){
          this.attributes =  this.attributes
          .map((attribute) => { 
              const filteredValues = attribute.value.filter((value) => {        
                let filterI={};
                Object.keys(this.selectedAttributes).map((attributeNameF,si) => {  
                  if(attribute.name!=attributeNameF){                                
                    const selectedValues = this.selectedAttributes[attributeNameF];  
                    filterI[attributeNameF+si.toString()]=selectedValues;     
                  }else{
                    filterI[attributeNameF+si.toString()]=value;
                  }         

                })                   
                return this.filterProducts_2(this.data.variablePrices,filterI) ;   
             });

            if ( filteredValues.length > 0  ) {
              filteredValues.map(x=>{
                this.filterAttributes[attribute.name+"_"+x]=true
              })             

              return { ...attribute, value: filteredValues };
            }
            return attribute;                       
          }).filter(Boolean);   

       
    },     
    filterProducts_2(products,selected){
       return products.some((product) => {               
          for (const key in selected) {           
            if (selected[key]) {
              const productValue=product.attrs.find(x=>x.name==key);             
              if (productValue && productValue.value !== selected[key]) {
                return false; // Product doesn't match all selected attributes
              }
            }
          }
          
          const isAvailable = this.data.hideUnavailableProductVariant ? product.available > 0 : true;
          return isAvailable && !product.delete; // Product matches all selected attributes
        });
       
    },
    initProductVariantSelect(){ 

        let variablePrices = {};
        this.data.attributes.forEach((attribute) => {        
          this.selectedAttributes[attribute.name] = "";
        });    
        this.attributes=JSON.parse(JSON.stringify(this.data.attributes));  
        this.attributes.map(attribute=>{
          attribute.value.map(x=>{           
               this.filterAttributes[attribute.name+"_"+x]=false              
            })
        })   

        this.data.variablePrices.some(item=>{        
          const isAvailable = this.data.hideUnavailableProductVariant ? item.available > 0 : true;
          if(!item.delete && isAvailable){
            item.attrs.map((attr,index)=>{             
              variablePrices[attr.name ] = { name: this.mobileVersion && this.data.formMode === "Progressive Form" && this.data.hasProgressiveVariants ? null : attr.value, qty: 0 }
              this.selectedAttributes[attr.name.replace(index,"")] = attr.value; 
            })
            return true;
          }          
        })  
        this.payload.variablePrices = variablePrices;           
        if (localStorage.getItem("cartSummaryCheckout")) {
         this.cartSummary = JSON.parse(localStorage.getItem("cartSummaryCheckout"));
          this.data.variablePrices.map(attr => {
            let f = this.cartSummary.filter(e => e.name == attr.name);
            attr.qty = f.length > 0 ? f[0].qty : 0;
          });
          this.$forceUpdate();
        } 
        
        if (localStorage.getItem("tuktukSummaryCheckout")) {
            this.storeData = JSON.parse(localStorage.getItem("tuktukSummaryCheckout"));           
            if(this.storeData.url==this.data.url && this.$route.query.step && this.$route.query.step==2){            
              this.selectedbumpArray=[...this.selectedbumpArray,...this.storeData.selectedbumpArray];
              this.cartSummary=[...this.cartSummary,...this.storeData.cartSummary];
              this.cartQuantity=this.storeData.cartQuantity;
              this.payload.variablePrices={...this.payload.variablePrices,...this.storeData.payloadVariablePrices};
              if(this.storeData.variablePrices){
                this.storeData.variablePrices.map((item,index)=>{
                  this.data.variablePrices[index].qty=item.qty;
                })
              }  
            }        
         } 

        },
     updateAttributeValueChild(payloadVariablePrices){      
      this.attributes= JSON.parse(JSON.stringify(this.data.attributes));
      this.attributes.map(attribute=>{
        attribute.value.map(x=>{           
              this.filterAttributes[attribute.name+"_"+x]=false            
          })
      }) 
      Object.keys(payloadVariablePrices).map(key=>{        
        const attributeName = key.slice(0, -1);      
        this.selectedAttributes[attributeName]=payloadVariablePrices[key].name;              
      }) 
      this.updateAttributeValue();
           
    },
    checkVariantSelection() {    
      let filter = false;


      if(this.data.multiplyVariations){         
          let isProductDeleted =true ;
          this.cartSummary.map(item=>{
            const isProduct=this.filterProducts_2(this.data.variablePrices, item.items);
         
           if(!isProduct && isProductDeleted){
            isProductDeleted=false;
           }
           return item;
          })
         
          filter=  isProductDeleted;
          if(this.data.multiplyVariations && this.data.cartOrder){
            const selected = Object.keys(this.payload.variablePrices);
              this.data.variablePrices.some((x) => {    
                let found = [];
                selected.map((key) => {
                  const attrF = x.attrs.find(x => x.name == key);
                  const selectedValues = this.payload.variablePrices[key];         
                  found.push(attrF.value == selectedValues.name)        
                })
                if (found.filter(Boolean).length == selected.length) {
                  if (x.delete) {
                    filter = false;
                  } else {
                    filter = true;
                  }
                  return true;
                }
              });
          }
      }else{
        const selected = Object.keys(this.payload.variablePrices);
        this.data.variablePrices.some((x) => {    
          let found = [];
          selected.map((key) => {
            const attrF = x.attrs.find(x => x.name == key);
            const selectedValues = this.payload.variablePrices[key];         
            found.push(attrF.value == selectedValues.name)        
          })
          if (found.filter(Boolean).length == selected.length) {
            if (x.delete) {
              filter = false;
            } else {
              filter = true;
            }
            return true;
          }
        });
      }

      
      this.isVariableItemSelected = filter;
    },
    shouldDisplayProductVariantOnCheckout(name, attrValue) {
      return !this.data.hideUnavailableProductVariant || (this.data.hideUnavailableProductVariant && !this.checkOption(name, attrValue));
    },
    filteredProductVariant(attrValues, attrName) {
      return attrValues.filter(attrValue => this.shouldDisplayProductVariantOnCheckout(attrName, attrValue));
    },
    onSubmittedPopUpEmailConfirm() {
      this.emailConfirmModal = false;

      this.saveDataOnSubmit();
      this.save();
    },
    shippingCouponAmountValidation(deliveryPrice) {
      let totalCouponDiscount = 0;
      if (this.payload.automaticDiscount && get(this.payload.automaticDiscount, 'discount_type') === 'moneyOffShipping') {
        totalCouponDiscount += get(this.payload.automaticDiscount, 'amount');
      }

      for (const coupon of this.payload.discounts) {
        if (get(coupon, 'discount_type') === 'moneyOffShipping') {
          totalCouponDiscount += coupon.amount;
        }
      }

      const remainingQuotaAmount = Math.max(deliveryPrice - totalCouponDiscount, 0);
      return remainingQuotaAmount;
    },
    showProductVariants(sectionName) {
      if (sectionName === 'productDetails' && this.data.hasProgressiveVariants) {
        const fields = this.data.requestedFields.filter(field => field.active);
        const totalFields = fields.length;
        const totalFieldsFilled = fields.filter(field => field.value !== '').length;
        return totalFieldsFilled === totalFields;
      }

      return true;
    },
    calEpayFee() {
      let fee = 0;
      if (this.data && this.data.ePaymentFeePaidBy === 'buyer') {
        if(this.payload && this.payload.payment){
          if (this.payload.payment == "bca_va" || this.payload.payment == "bni_va" || this.payload.payment == "echannel" || this.payload.payment == "bri_va") {
            fee = 4000;
          }
          if (this.payload.payment == "gopay") {
            fee = Math.round((this.totalPrice * 2) / 100);
          }
          if (this.payload.payment == "credit_card") {
            fee = Math.round(4000 + (this.totalPrice * 11) / 100);
          }
          if (this.payload.payment == "QRIS") {
            fee = Math.round((this.totalPrice * 0.7) / 100);
          }
        }
      }
      return fee;
    },
    onAddressChange(val, from = "autofill") {
      const keyMap = {
        province: 'PROVINCE_NAME',
        city: 'CITY_NAME',
        district: 'DISTRICT_NAME',
        subdistrict: 'SUBDISTRICT_NAME',
        autofill: 'ENTER_CITY_NAME',
      };

      const key = keyMap[from];
      if (!key) return;

      const targetField = this.data.requestedFields.find(field => field.key === key);
      if (targetField) {
        targetField.value = val.customerFULL_AUTOFILL;
      }
    }
  },
  computed: {
    isFbPixelDisabled() {
      return this.setting && (this.setting.isFbPixel === 'false' || this.setting.isFbPixel === false);
    },
    isGtmDisabled() {
      return this.setting && (this.setting.isGtm === 'false' || this.setting.isGtm === false);
    },
    filteredProductImages() {
       if(!this.data.showProductVariant) {
        return this.productImages.filter(img => img.name === undefined || img.name === null);
       }

       return this.productImages;
    },
    isAutoFillForm() {
      return this.user.isAutoFillForm || false
    },
    // SPX is only offered when Mengantar returned a priced service that supports
    // the buyer's current payment method.
    courierOptionDataAvailable() {
      return this.courierOptionDataFinal.filter(option => this.isSpxOptionAvailable(option))
    },
    // Same switches as hasActiveShippingCourier on the server: regular is on unless turned
    // off, cargo only when turned on, so a disabled cargo courier is never offered.
    activeShippingConfig() {
      return this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
        ? (this.data.shippingCOD || {})
        : this.data
    },
    courierListRegular() {
      if (this.activeShippingConfig.hasRegularShipping === false) return []

      const courierOrders = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
        ? (this.data.shippingCOD.courierType || [])
        : (this.data.courierType || [])

      const lists = [...this.courierOptionDataAvailable]
        .filter(courier =>
          this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
            ? this.data.shippingCOD[courier.key]
            : this.data[courier.key]
        )
        .sort((a, b) => courierOrders.indexOf(a.key) - courierOrders.indexOf(b.key))
      
      return lists
    },
    // With the coverage check on, a courier that does not reach the address for the chosen
    // payment stays listed but cannot be picked.
    selectableShippingCouriers() {
      const couriers = [...this.courierListRegular, ...this.courierListCargo]
      if (!this.data.isShippingCoverageCheckEnabled) return couriers

      return couriers.filter(courier => (
        courier.unsupported !== true &&
        !(this.payload.payment === 'COD' && courier.unsupported_cod === true)
      ))
    },
    // Every listed courier is out of reach for the buyer's address.
    isShippingAddressUnreachable() {
      return !this.loadingPrice &&
        [...this.courierListRegular, ...this.courierListCargo].length > 0 &&
        this.selectableShippingCouriers.length === 0
    },
    courierListCargo() {
      if (this.activeShippingConfig.hasCargoShipping !== true) return []

      const courierOrders = this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
        ? (this.data.shippingCOD.cargoCourierType || [])
        : (this.data.cargoCourierType || [])

      const lists = [...this.courierOptionDataCargo]
        .filter(courier =>
          this.data.isPaymentTypeHaveDifferentValue && this.payload.payment === 'COD'
            ? this.data.shippingCOD[courier.key]
            : this.data[courier.key]
        )
        .sort((a, b) => courierOrders.indexOf(a.key) - courierOrders.indexOf(b.key))
      
      return lists
    },
    compfieldsPositionMobile() {
      const fieldsOrder = cloneDeep([...this.data.fieldsPositionMobile]);
      let componentGroupOrders = []
      
      if (this.data.componentGroupLists) {
        componentGroupOrders = this.mobileVersion
          ? this.data.componentGroupLists.mobile.flatMap(section => section.fields)
          : this.data.componentGroupLists.desktop.flatMap(section => section.fields);
      }
      
      if (componentGroupOrders.length > 0) {
        fieldsOrder.sort((a, b) => {
          const getKey = (item) => item.uniqueName || item.name;
          return componentGroupOrders.indexOf(getKey(a)) - componentGroupOrders.indexOf(getKey(b))
        })
      }

      return this.mobileVersion ? fieldsOrder : ["singledummy"];
    },
    quantity() {
      let q = this.data.requestedFields.find(d => d.field == 'quantity')
      return parseInt(q ? q.value ? q.value : 1 : 1)
    },
    weight() {
      let weight = this.data.weight
      if (this.data.enableProductOptions && this.data.variablePrices && this.data.variablePrices.length) {
        weight = 0
        if (this.cartSummary.length > 0) {
          this.cartSummary.map(async e => {
            weight = weight + parseInt(e.weight) * parseInt(e.qty)
          })
        } else {
          this.data.variablePrices.map(one => {
            if (one.qty && parseInt(one.qty)) {
              weight = weight + parseInt(one.weight) * parseInt(one.qty)
            }
          })
        }
      } else {
        weight = weight * (this.quantity ? this.quantity : 1)
      }
      if (this.data && this.data.isBump && this.selectedbumpArray && this.selectedbumpArray.length >= 0) {
        // price = price + parseFloat(this.data.bumpPrice)
        this.selectedbumpArray.map((bumpData) => {
          // const bumpData = this.data.bumpArray.find((data) => data.bump_id == bump_id)
          if (bumpData) {
            weight = weight + parseFloat(bumpData.bumpWeight ? bumpData.bumpWeight : 0)
          }
        })
      }
      // if (this.payload.bump && this.data.bumpWeight) {
      //   weight = weight + parseInt(this.data.bumpWeight)
      // }
      return weight
    },
    deliveryPrice() {
      const isPaymentCOD = this.payload.payment === 'COD';
      const shippingType = isPaymentCOD ? this.data.shippingCOD.shippingType : this.data.shippingType;
      const flatShippingPrice = isPaymentCOD ? this.data.shippingCOD.flatShippingPrice : this.data.flatShippingPrice;
      let price = 0
      if (shippingType == 'automated') {
        price = this.payload.deliveryPrice ? this.payload.deliveryPrice : 0
      }
      if (shippingType == 'flat') {
        price = flatShippingPrice ? flatShippingPrice : 0
      }
      return parseInt(price)
    },
    codPrice() {
      let codPrice = 0;
      if (this.payload.payment == 'COD') {
        const cartPrice = this.cartSummary.length > 0 ? this.cartSummary.reduce((a, b) => a + this.getCartSubPrice(b), 0) : this.price;
        const shippingConfig = this.data.isPaymentTypeHaveDifferentValue && this.data.shippingCOD ? this.data.shippingCOD : this.data;
        const additionalCost = this.data.addShipping ? parseFloat(shippingConfig.additionalCost || 0) : 0;
        let price = this.data.CODSettings.feeType == "productShipping" ? (cartPrice + this.deliveryPrice + additionalCost) : cartPrice;
        codPrice = parseFloat(price ? price : 0) * (+this.data.CODSettings.percent / 100)
        if (parseFloat(this.data.CODSettings.courierFeeMin) > codPrice) {
          codPrice = parseFloat(this.data.CODSettings.courierFeeMin)
        }
        const courierFeeMax = parseFloat(this.data.CODSettings.courierFeeMax)
        if (courierFeeMax > 0 && courierFeeMax < codPrice) {
          codPrice = courierFeeMax
        }
      }
      return codPrice ? codPrice.toFixed() : codPrice
    },
    cogsPrice() {
      let price = 0
      let keys = Object.keys(this.payload.variablePrices)
      if (this.data.type !== 'simple' && this.data.variablePrices && this.data.variablePrices.length && keys.length) {
        this.data.variablePrices.map(attr => {
          if (attr.qty) {
            const tempPrice = attr.priceCompare ? attr.priceCompare : attr.price;
            let qty = parseInt(!this.data.multiplyVariations ? this.quantity : attr.qty)
            let subPrice = attr.costPerItem ? attr.costPerItem : tempPrice
            price = price + subPrice * qty
          }
        })
      } else {
        price = this.data.costPerItem ? this.data.costPerItem : 0
        // NOTE: CODE BELOW IS OLD CALCULATION
        // price = this.data.costPerItem ? this.data.costPerItem : this.price
        // UPDATED BASED ON THIS TICKET https://mengantar.atlassian.net/browse/MFM-142

        price = this.data.costPerItem ? this.data.costPerItem : 0
        price = price * this.quantity
      }
      return price
    },
    shouldRecalculateAutomaticDiscount() {
      if (get(this.payload, 'automaticDiscount.code.length') && get(this.payload, 'automaticDiscount.discount_type') === 'moneyOffShipping') {
        const addressForm = this.data.requestedFields.find(function (reqField) {
          return reqField.field === 'address';
        });

        if (!this.data.addShipping || !addressForm) {
          return false;
        }
      }

      return true;
    },
    shippingHideView() {
      return this.payload.payment === 'COD' ? get(this.data, 'shippingCOD.shippingHideView', false) : get(this.data, 'shippingHideView', false);
    }
  },
  beforeMount() {     
    if((this.data.nuxt2 && process.client) || !this.data.nuxt2){  
      this.initProductVariantSelect();
      let tempfilter = this.data.paymentType.filter(e => e.active)[0];
      this.payload.payment = tempfilter && this.data.showPayment ? (tempfilter.type != "E-Payment" ? tempfilter.type : (this.data && this.data.epaymentSettings && this.data.epaymentSettings[0] ? this.data.epaymentSettings[0].id : "")) : undefined;
      let self = this;

      // load split price ***** 
      if (this.data.formOption == 'multiple' && this.data.enableSplitPrice) {
        const splitPriceData = this.data.splitPriceData.find((priceData) => priceData.label == this.data.selectedSplit)
        if (splitPriceData) {
          this.data.price = splitPriceData.bidPrice //actual
          this.data.priceCompare = splitPriceData.salePrice && splitPriceData.salePrice != 0 ? splitPriceData.salePrice : null // discountedPrice
        }
      }

      this.data.bumpArray.map(bumpData=>{
        if(!('bumpColor' in bumpData) && !bumpData.bumpColor){
          bumpData.bumpColor='#203551';
        }
        return bumpData;
      })

      if(this.data.isCheckedBumpProduct && this.data.showBumpProduct && this.data.isBump){       
        this.data.bumpArray.map(bumpData=>{
          const bumpIndex=this.selectedbumpArray.findIndex(x=>x.bump_id==bumpData.bump_id);
          if(bumpIndex==-1){
            this.selectedbumpArray.push(bumpData);
          }             
        })
      }

      setTimeout(() => {
        if (this.checkout_id) {
          this.populateCheckout();
        } else {
          let currentDomain = window.location.hostname;

          if (localStorage.getItem('CheckoutCustomerInfo') || localStorage.getItem('CheckoutAddressInfo')) {

            let checkoutData = JSON.parse(localStorage.getItem('CheckoutCustomerInfo'));
            let checkoutInfo = JSON.parse(localStorage.getItem('CheckoutAddressInfo'));

            if (checkoutData[currentDomain]) {
              (checkoutData[currentDomain] || []).forEach((inputData, index) => {
                if (inputData.inputType === 'date' && checkoutData[currentDomain][index].value) {
                  checkoutData[currentDomain][index].value = new Date(checkoutData[currentDomain][index].value)
                }
              })

              //this.data.requestedFields = checkoutData[currentDomain]
              this.data.requestedFields.map((attr) => {
                if (attr.active) {
                  if (attr.field == 'address') {
                    const obj = checkoutData[currentDomain].find((data) => data.field == attr.field && data.key == attr.key)
                    attr.value = obj ? obj.value : ''
                  } else {
                    const obj = checkoutData[currentDomain].find((data) => data.field == attr.field)
                    attr.value = obj ? obj.value : ''
                  }
                }
                if (checkoutInfo != null && checkoutInfo[currentDomain]) {
                  this.payload.address = checkoutInfo[currentDomain];
                  if (attr.field == 'address' && attr.key) {
                    let r = attr.key.split('_')[0]
                    attr.value = checkoutInfo[currentDomain][r] ? checkoutInfo[currentDomain][r] : false
                  }
                }
              })

              const filledFields = getFilledFieldNames(this.data.requestedFields)
              if (filledFields.length) {
                this.autofillSource = getAutofillSource(currentDomain, this.isAutoFillForm)
                this.trackAutofillEvent({
                  event: AUTOFILL_EVENT.CHECKOUT_AUTOFILLED,
                  source: this.autofillSource,
                  filledFields
                })
              }
            }
          }
        }
      }, 500)

      this.updatePrices();
      this.handleAutofill = debounce(async function () {
        self.createAbandon();
      }, 500);
      this.handleEstimate = debounce(async function (val, refetch = false) {
       await self.estimate(val, refetch);
      }, 500);
      if(this.data.showCoupon) {
        this.getDiscountLists(this.data.discount_code);
        this.getAutomaticDiscountLists();
      }
    }
  },
  async mounted() {
    if((this.data.nuxt2 && process.client) || !this.data.nuxt2){ 
      localStorage.removeItem('orderData');
      localStorage.removeItem('checkOrderMountCount');
      localStorage.removeItem('orderDataPaymentSuccess');
      localStorage.removeItem('orderCountPaymentSuccess');
      localStorage.removeItem('orderDataPaymentConfirm');
      localStorage.removeItem('orderCountPaymentConfirm');
      this.checkCaptchaOnProduct();  //function for checking security  captcha
      let self=this;
      this.updateProductImages();

      if (self.data.settingRedirect && ((self.data.settingRedirect == 'url' && self.data.settingRedirectUrl !== '') || (self.data.settingRedirect == 'whatsappSeller' && self.data.settingRedirectWAnumber !== '') || (self.data.settingRedirect == 'whatsappSequence' && self.data.settingRedirectWAnumbers.length > 0))) { 
        // window.onbeforeunload = (event) => { this.exit(event, self) };
        window.addEventListener("popstate", (event) => {   
            this.exit(event,this);
          });  

          document.addEventListener("click", () => {
            this.goNext();
            this.confirmBox=false;
          });  
          if (navigator.userAgent.includes('Chrome') || navigator.userAgent.includes('Safari')) {
            this.confirmBox=true;
            if(this.data.settingRedirectMessage && this.data.settingRedirectMessage!=""){
              this.settingRedirectMessage=this.data.settingRedirectMessage;
            }     
          } else {
            this.confirmBox=false;
            this.goNext();
          }
      }

    // this.checkLast24HourProduct();
      this.initiateScript();
      this.createScripts();
      // default order summary position 
      this.data.summaryPlacement = this.data && this.data.summaryPlacement ? this.data.summaryPlacement : 'Before Buy Button';      
      this.calculateShippingDiscount();  
      this.updatePrices(); 
      // Check last item and if it`s not buy button show additional button [MFM-560]  
      // this.data.fieldsPositionMobile=this.data.fieldsPositionMobile.filter(item=>{        
      //   if(item.buttonVar){
      //     return  this.data[item.buttonVar]
      //   }else{
      //     return true
      //   }
      // });   
      // [MFM-1035] comment duplicate button
      // if( this.data.fieldsPositionMobile[this.data.fieldsPositionMobile.length-1].name!="buyButton"){
      //   const buyNow=this.data.fieldsPositionMobile.find(x=>x.uniqueName=="buyButton")
      //     this.data.fieldsPositionMobile.push(buyNow);
      // }  
  
      // MFM-1247 for old products
      if(this.data && (this.data.shipFrom || this.data.shipFrom == '') && this.data.multipleShipFrom.length == 0) {
        this.data.multipleShipFrom.push(this.data.shipFrom);
      }

      if (this.data.requestedFields) {
        for (const requestedField of this.data.requestedFields) {
          if (requestedField.field === 'quantity' && !Number(requestedField.value)) {
            requestedField.value = Number(requestedField.default);
          }

          if (requestedField.field === 'quantity' && this.data.formMode === "Progressive Form" && requestedField.active) {
            requestedField.value = null;
          }
        }
      }
    }
    this.isComponentReady = true;
  },
  watch: {
    'selectedbumpArray': {
      async handler() {
        this.updatePrices();
        this.handleEstimate(true);
      },
      deep: true,
    },
    "data.requestedFields": {
      handler(val) {     
        this.updatePrices(val);               
      },
      deep: true,
    },
    'payload.variablePrices': {
      async handler(val) {
        this.updatePrices();
        this.updateAttributeValueChild(val);
        this.checkVariantSelection();
        this.updateProductImages();
        
        if (this.cartSummary.length == 0 && !this.$route.query.step) {
         let keys = Object.keys(this.payload.variablePrices);
          let dataVal = this.payload.variablePrices
            ? keys.map(o => this.payload.variablePrices[o].name).join(' / ')
            : undefined;

          this.data.variablePrices.map(e => { 
            if (e.name == dataVal) { 
              e.qty = this.getSelectedVariantQty()
            } else {
               e.qty = 0; 
              }
          });
        }    
        this.showChoosenData();
        
      },
      deep: true,
    },
    'data.variablePrices': {
      async handler(val) {      
        this.updatePrices();
        this.handleEstimate(true)
        this.checkVariantSelection();
        this.updateProductImages();
        this.isAnyVariantwithQtyOne = val.filter(e => e.qty > 0);
      },
      deep: true,
    },
    'payload.bump': {
      async handler() {
        this.updatePrices();
        this.handleEstimate(true)
      },
      deep: true,
    },
    'weight': {
      async handler() {
        this.handleEstimate(true)
      },
    },
    'payload.address': {
      async handler() {
        this.handleEstimate()
        this.calculateShippingDiscount();
      },
      deep: true,
    },
    'payload.deliveryCourier': {
      handler(val) {
        this.payload.deliveryPrice = this.delivery[val] && this.delivery[val].length ? this.delivery[val][0].price : 0
        this.payload.deliveryType = this.delivery[val] && this.delivery[val].length && this.delivery[val][0].type ? this.delivery[val][0].type : 'REG'     
      },
    },
    "payload.deliveryPrice": {
      handler() {
        this.calculateShippingDiscount();
        this.updatePrices();
      },
    },
    "payload.payment": {
      async handler() {
        this.payload.uniquePrice = undefined
        const refetch = !!this.data.shippingCOD.originalShippingCost !== !!this.data.originalShippingCost;
        this.handleEstimate(false, refetch);
        this.reselectUnavailableSpx();
        this.calculateShippingDiscount();
        this.updatePrices();
      },
    },       
    "data.shippingDiscount": {
      handler() {       
        this.calculateShippingDiscount();      
        this.updatePrices();
      },
      deep: true,
    },    
    "data.shippingCOD.shippingDiscount": {
      handler() {       
        this.calculateShippingDiscount();      
        this.updatePrices();
      },
      deep: true,
    },          
  },
}
</script>

<style lang="scss" scoped>

.overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 2;
  }

  .confirm-box {
    position: absolute;
    width: 40%;
    top: 25%;
    left: 25%;
    text-align: center;
    background: white;
    border-radius: 5px;
    padding: 20px;
  }

  .close {
    cursor: pointer;
  }
.content-page-empty {
  min-height: auto !important;
  
  &--embed {
    padding: 0 !important;

    &::v-deep {
      .embed-checkout-right-col {
        @media screen and (min-width: 768px) {
          margin-top: 0;
          margin-bottom: 10px;
        }
      }

      .Nosidebar-width {
        #left-sidebar:not(:first-of-type) .embed-checkout-right-col,
        #right-sidebar:not(:first-of-type) .embed-checkout-right-col,
        .copyright-content {
          margin-top: 16px !important;
        }
      }
    }
  }

}

.order-summary-list+.order-summary-list {
  margin: 15px 0 0;
  padding: 15px 0 0;
  border-top: 1px dashed #E0E9F4;
}

.embed-checkout-main.checkout-nosidebar {
  padding: 15px;
}

.checkout-nosidebar-narrow-canvas {
  &.classic {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
}

.p-0 {
  padding: 0px !important;
}

.embed-checkout__header_nosidebar-narrow-canvas {
  margin: unset !important;
  margin-top: 0px !important;
  max-width: unset !important;
}
</style>

<style lang="scss">
// @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;900&display=swap');
// @import url('../../assets/fonts/inter.woff2');

.vs-notification--danger .vs-notification__icon:has(.icon-order-below-epay-fee) {
  top: 50% !important;
  transform: translateY(-50%);
}

// OLD CODE STYLING
@media (max-width: 768px) {
  .chooseVariant.popup>div {
    position: fixed;
    bottom: 0;
    overflow-y: auto;
  }

  .small-label.choose-variant {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #203551;
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  transition: opacity 0.8s ease;
  opacity: 0;
}

.your-cart-title {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  color: #203551;
}

.increDecre-btn-wrap {
  background-color: #F6F8FC;
  border: 1px solid #E0E9F4;
  border-radius: 0 8px 8px 0;
  padding: 6px !important;
  height: 44px;
  align-items: center;
  margin: 0 !important;
  font-size: 14px;
}

.cart-counter {
  background: #E14D4D;
  border-radius: 100%;
  width: 18px;
  height: 18px;
  font-size: 8px;
  position: absolute;
  right: -10px;
  top: -9px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.total-variant-info {
  background: #ffffff;
  border: 1px solid #bfcee0;
  border-radius: 8px;
  padding: 10px;
}

.p-big {
  padding: 30px;
}

.small-side {
  background-color: #F6F8FC;
  border-radius: 6px;
}

.left-side {
  padding-left: 0;
}

.right-side {
  padding-right: 0;
}

.RightLeftsidebar-width {
  .vs-select {
    &.activeOptions {
      .vs-select__input {
        // border-color: #BFCEE0 !important;
        border: 1px solid transparent;
      }
    }
  }

  .vs-form-control input {
    border-color: #BFCEE0 !important;
  }

  .right-big-label,
  .big-label {
    font-size: 24px;
    font-weight: 600;
    line-height: 29px;
    color: #203551;
  }

  .spaceR {
    padding-right: 30px;
  }

  .common-font {
    &.rightLeft-big-label {
      font-weight: 600;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0.02em;
      color: #203551;
    }
  }
}

.meng-card {
  @media(max-width: 767px) {
    margin: 5px auto;
  }

  @media(min-width: 768px) {
    margin: 50px auto;
  }

  .title-text {
    font-size: 36px;
    line-height: 44px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #203551;
    max-width: 98%;
    margin: auto;
  }

  .pro_image {
    img {
      border-radius: 8px;
    }
  }

  .checkout-check {
    .vs-checkbox-label {
      color: #203551;
      font-weight: 400;
      font-size: 14px;
    }
  }

  .copyright-texxt {
    font-size: 12px;
    line-height: 18px;
  }

  .demoTitle {
    margin: 0 0 20px;
    font-weight: 600;
    font-size: 22px;
    line-height: 27px;
    letter-spacing: 0.02em;
    color: #203551;
  }

  .sumPro-name {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #203551;
  }

  .checkout-form {
    flex: 0 0 calc(100% - 410px);
    width: calc(100% - 410px);
    padding: 0;

    &-title {
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      letter-spacing: 0.02em;
      color: #203551;
    }

    @media (max-width: 991px) {
      flex: 0 0 100%;
      width: 100%;
      padding: 0;
    }
  }

  .checkout-detail {
    flex: 0 0 380px;
    width: 380px;
    padding: 0;

    &.minimalist {
      padding: 0;

      @media (max-width: 575px) {
        padding: 0;
      }

      .shoe-detail {
        background-color: #F6F8FC;
        border-radius: 6px;
        padding: 15px;
        text-align: left;
      }
    }

    &.classic-right {
      padding: 0;

      @media (max-width: 991px) {
        padding: 0;
      }
    }

    &.classic-left {
      padding: 0;

      @media (max-width: 991px) {
        padding: 0;
      }

      @media (max-width: 575px) {
        padding: 0;
      }
    }

    @media (max-width: 991px) {
      flex: 0 0 100%;
      width: 100%;
    }
  }


  .shoe-detail {
    border-radius: 8px;
  }

  .b-title {
    margin-bottom: 15px;
  }

  .order-summary {
    margin: 20px 0 0;
  }

  .vs-input {
    border: 1px solid #BFCEE0;
    background-color: #fff !important;
    border-radius: 8px;
    padding: 10px 15px;
    font-size: 13px;
    color: #6C7E95;
    line-height: 18px;
    min-height: 40px;
    font-weight: 400;

    &::placeholder {
      color: #6C7E95 !important;
    }
  }

  .Nosidebar-container {
    &.bottom-bar-text {
      @media(max-width: 575px) {
        padding-bottom: 0;
        margin-top: 16px;
      }
    }
  }
}

.sumPro-name {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  color: #203551;
}

.summary-label {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.02em;
  color: #6C7E95;
}

.summary-total {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  letter-spacing: 0.02em;
  color: #203551;
}

.summary-tax {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.02em;
  color: #5D6F86;
  text-align: left;
}

.common-font {
  font-weight: 400;
  letter-spacing: 0.02em;

  &.title-under-image {
    font-weight: 600;
    font-size: 28px;
    line-height: 34px;
    color: #203551;
  }

  &.tagline-title {
    font-weight: normal;
    font-size: 18px;
    line-height: 18px;
    text-align: center;
    letter-spacing: 0.02em;
    color: #6C7E95;
    margin: 0;
  }

  &.seal-title {
    margin: 0 0 0 10px;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    text-transform: uppercase;
    color: #6C7E95;
    max-width: 112px;
    white-space: pre;

    @media screen and (max-width: 560px) {
      font-size: 12px;
    }
  }

  &.product-desc {
    font-size: 12px;
    line-height: 19px;
    letter-spacing: 0.02em;
    color: #6C7E95;
  }

  &.big-label {
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    color: #203551;
    margin: 0;
  }

  &.bullet-name {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #203551;
    text-align: left;
  }

  &.bullet-name2 {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0.02em;
    color: #203551;
  }

  &.order-summary-header {
    font-weight: 400;
    font-size: 12px;
    line-height: 15px;
    color: #6C7E95;
  }

  &.product-name {
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.02em;
    text-transform: capitalize;
    color: #203551;
  }

  &.regular_price {
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: right;
    letter-spacing: 0.02em;
    color: #203551;
  }

  &.sale_price {
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    text-align: right;
    letter-spacing: 0.02em;
    text-decoration-line: line-through;
    color: #FA5757;
  }

  &.total {
    font-weight: 600;
    color: #203551;

    &.title {
      font-size: 16px;
      line-height: 19px;
    }

    &.price {
      font-size: 16px;
      line-height: 19px;
    }
  }
}

.pro_image img {
  width: -webkit-fill-available;
}

.bullet-img {
  margin-right: 12px;
  // width: 18px;
  // height: 18px;
}

.center-side {
  background: #F6F8FC;
  border-radius: 8px;
}

.Nosidebar-width {
  max-width: 640px;
  width: 100%;
}

.nosidebar-narrow-canvas-width {
  width: 100%;
  margin: auto !important;

  @media screen and (min-width: 561px) {
    max-width: 400px !important;
  }
}

.RightLeftsidebar-width {
  max-width: 1140px;
  width: 100%;
}

.demoTitle {
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 27px;
  letter-spacing: 0.02em;
  color: #203551;
}

.order-details {
  border-radius: 8px !important;
}

.embed-leftHide .leftTemp-seal {
  display: none;
}

@media screen and (max-width: 767px) {
  .embed-leftSidebar-popup-width {
    max-width: 353px;
    width: 100% !important;
  }
}

@media screen and (min-width: 768px) {
  .embed-leftSidebar-popup-width {
    max-width: 460px;
    width: 100% !important;
  }
}

@media screen and (max-width: 991px) {
  .Nosidebar-width,
  .RightLeftsidebar-width {
    .preview-main {
      padding: 20px 20px;
    }
  }
}

@media screen and (max-width: 767px) {
  .Nosidebar-width,
  .RightLeftsidebar-width {
    padding: 0px 5px;

    .common-font {
      &.rightLeft-big-label {
        font-size: 19px;
      }
    }

    .mobile-img {
      .mr-1 {
        img {
          width: 32px;
        }
      }
    }
  }
  .Nosidebar-width,
  .RightLeftsidebar-width {
    .preview-main {
      padding: 20px 15px;
    }
  }
}

.options-group {
  display: grid;
  grid-gap: 15px;

  &.grid-cols-1 {
    grid-template-columns: 1fr;
  }

  &.grid-cols-2 {
    grid-template-columns: 1fr 1fr;
  }
}

.options-wrap .qty-input input.vs-input {
  width: 60px !important;
  background: none !important;
  border: none !important;
  text-align: center;
  color: #203551 !important;
  font-weight: 500;
}

.options-wrap .qty-input {
  opacity: 1;
}

.options-wrap .option-name {
  padding: 0 15px;
}

.big-label {
  font-size: 24px;
  font-weight: 600;
  line-height: 29px;
  color: #203551;
  margin-bottom: 15px !important;
}

.product-desc+.get-container {
  margin: 20px 0 0;
}

.checkout-info+.get-container {
  margin: 20px 0 0;
}

.get-container .common-font.big-label {
  margin-bottom: 0 !important;
}

.get-content {
  margin: 15px 0 0;
}

.get-list+.get-list {
  margin: 10px 0 0;
}

.get-list .bullet-name2 {
  line-height: 20px;
}


.testimonial-container {
  margin: 0;
  padding: 20px 0 0;
  border-top: 1px solid #E0E9F4;
}

.testimonial-container.classic {
  margin: 0;
  padding: 0;
  border-top: 0;

  @media (max-width: 991px) {
    margin-top: 10px;
    padding: 0;
  }
}

.checkout-container {
  &.classic {
    @media (max-width: 767px) {
      padding: 0;
    }

    @media (max-width: 575px) {
      padding: 0;
    }
  }
}

.save-nextTime .vs-input {
  min-height: 18px;
}

.testimonials-list+.testimonials-list {
  margin: 10px 0 0;
  padding: 10px 0 0;
  border-top: 1px solid #E0E9F4;
}

.Nosidebar-container {
  padding-bottom: 0;
}





// embed-popup 
.popup-main-wrapper>div {
  @media(max-width: 575px) {
    padding: 0 !important;
  }
}

.popup-main-wrapper {
  @media(max-width: 575px) {
    margin-top: 28px;
    margin-bottom: 12px;
  }

  @media(min-width: 576px) {
    padding: 28px 20px 0px;
  }
}

.embed-popup-footer {
  margin-top: 20px;

  @media(min-width: 576px) {
    margin-bottom: 20px;
  }
}

.popup-form>div {
  border-radius: 12px;
}

.popup-form>div>button {
  @media(max-width: 575px) {
    top: -39px !important;
    right: 9px !important;
  }

  @media(min-width: 576px) {
    top: -10px !important;
    right: -10px !important;
  }
}

.popup-form>div>button .vs-icon-close::after,
.popup-form>div>button .vs-icon-close::before {
  margin-top: 15px;
  right: 10px;
}

.noMarginInMobile>div {
  @media(max-width: 575px) {
    margin: 0;
  }
}

.embed-rightSidebar-popup-footer {
  @media(max-width: 575px) {
    margin: 20px auto 10px;
  }

  @media(min-width: 576px) {
    margin: 20px auto 20px;
  }
}

.embed-leftSidebar-popup-footer {
  margin: 20px auto 20px;
}

.copyright-content--leftsidebar--mobile{
  display: block;
  @media screen and (min-width: 1024px) {
    display: none !important;
  }
}

.embed-checkout-main__container {
  &.main-container-canvas-narrow {
    // border: 1px solid #dadada;
    width: 100%;
    max-width: 100%;
    border-radius: 12px;
    padding: 0px;

    @media screen and (min-width: 561px) {
      max-width: 100%;
    }

    .bottom-component {
      margin-top: 0px !important;
    }
  }
}
.checkout-nosidebar-narrow-canvas {
  .main-container-canvas-narrow {
    &.is-mobile {
      .testimonial-wrapper {
          .testi-arrows.slick-prev {
            top: -27% !important;
            left: 88% !important;
          }

          .testi-arrows.slick-next {
            top: -27% !important;
            left: 95% !important;
          }
        }
    }
    &:not(.is-mobile) {
      .testimonial-wrapper {
        .testi-arrows.slick-prev {
          top: -54% !important;
          left: 88% !important;
        }

        .testi-arrows.slick-next {
          top: -54% !important;
          left: 95% !important;
        }
      }
    }
  }
}

.pop-up-email-confirmation {
  .vs-dialog {
    .vs-dialog__content {
      padding: 24px;

      .main-content-email-confirm {
        display: flex;
        flex-direction: column;
        gap: 14px;

        .header {
          display: flex;
          flex-direction: column;

          .title {
            font-family: Inter;
            font-size: 24px;
            font-weight: 600;
            text-align: left;
            color: #203551;
          }

          .subtitle {
            font-family: Inter;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #6C7E95;
          }
        }

        .form-email {
          display: flex;
          flex-direction: column;
          gap: 8px;

          .label-email {
            font-family: Inter;
            font-size: 16px;
            font-weight: 500;
            text-align: left;
          }

          .input-email {
            font-family: Inter;
            font-size: 14px;
            font-weight: 400;
            text-align: left;
            color: #203551;
            width: 100%;
            height: 44px;
            border-radius: 8px;
            border: 1px solid #E0E9F4;

            label {
              font-family: Inter;
              font-size: 14px;
              font-weight: 400;
              text-align: left;
              color: #6C7E95;
            }

            &.is-invalid {
              border: 1px solid #F53535;
            }
          }

          .invalid-email {
            font-family: Inter;
            font-size: 12px;
            font-weight: 400;
            text-align: left;
            color: #F53535;
          }
        }

        .instruction {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 4px;
          height: 40px;
          padding: 10px;
          border-radius: 8px;
          border: 1px solid #6C92E4;
          box-shadow: 0px 1.5px 4px -1px #0A090B12;

          .label {
            font-family: Inter;
            font-size: 14px;
            font-weight: 500;
            text-align: left;
            color: #4272DD;
          }
        }

        .button-container {
          display: flex;

          .confirm-button {
            width: 100%;
            height: 40px;
            padding: 10px 16px;
            border-radius: 8px;
            border: 1px solid #F6F8FC;
            background-color: #F6F8FC;

            color: #6C7E95;
            font-family: Inter;
            font-size: 14px;
            font-weight: 500;
            text-align: center;

            &.save {
              background-color: #2E47BA;
              color: #ffffff;
              box-shadow: 0px 1px 2px 0px #0000001F;
            }

            &.disabled {
              cursor: not-allowed;
            }
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">

 @import '@/assets/styles/pages/checkout/index.scss';
 @import '@/assets/styles/pages/checkout/components/form/right.scss';
 @import '@/assets/styles/pages/checkout/components/form/left.scss';
</style> 
